"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "accessibleDisabled", {
  enumerable: true,
  get: function () {
    return _accessibleDisabled.default;
  }
});
Object.defineProperty(exports, "addOn", {
  enumerable: true,
  get: function () {
    return _addOn.default;
  }
});
Object.defineProperty(exports, "air", {
  enumerable: true,
  get: function () {
    return _air.default;
  }
});
Object.defineProperty(exports, "allenKey", {
  enumerable: true,
  get: function () {
    return _allenKey.default;
  }
});
Object.defineProperty(exports, "aluminiumCan", {
  enumerable: true,
  get: function () {
    return _aluminiumCan.default;
  }
});
Object.defineProperty(exports, "apple", {
  enumerable: true,
  get: function () {
    return _apple.default;
  }
});
Object.defineProperty(exports, "applePay", {
  enumerable: true,
  get: function () {
    return _applePay.default;
  }
});
Object.defineProperty(exports, "ar", {
  enumerable: true,
  get: function () {
    return _ar.default;
  }
});
Object.defineProperty(exports, "archiveBox", {
  enumerable: true,
  get: function () {
    return _archiveBox.default;
  }
});
Object.defineProperty(exports, "arrowClockwise", {
  enumerable: true,
  get: function () {
    return _arrowClockwise.default;
  }
});
Object.defineProperty(exports, "arrowCloudIn", {
  enumerable: true,
  get: function () {
    return _arrowCloudIn.default;
  }
});
Object.defineProperty(exports, "arrowCloudOut", {
  enumerable: true,
  get: function () {
    return _arrowCloudOut.default;
  }
});
Object.defineProperty(exports, "arrowCounterclockwise", {
  enumerable: true,
  get: function () {
    return _arrowCounterclockwise.default;
  }
});
Object.defineProperty(exports, "arrowDown", {
  enumerable: true,
  get: function () {
    return _arrowDown.default;
  }
});
Object.defineProperty(exports, "arrowDownBackwards", {
  enumerable: true,
  get: function () {
    return _arrowDownBackwards.default;
  }
});
Object.defineProperty(exports, "arrowDownForwards", {
  enumerable: true,
  get: function () {
    return _arrowDownForwards.default;
  }
});
Object.defineProperty(exports, "arrowDownFromBase", {
  enumerable: true,
  get: function () {
    return _arrowDownFromBase.default;
  }
});
Object.defineProperty(exports, "arrowDownToBase", {
  enumerable: true,
  get: function () {
    return _arrowDownToBase.default;
  }
});
Object.defineProperty(exports, "arrowDownToLine", {
  enumerable: true,
  get: function () {
    return _arrowDownToLine.default;
  }
});
Object.defineProperty(exports, "arrowForkRight", {
  enumerable: true,
  get: function () {
    return _arrowForkRight.default;
  }
});
Object.defineProperty(exports, "arrowLeft", {
  enumerable: true,
  get: function () {
    return _arrowLeft.default;
  }
});
Object.defineProperty(exports, "arrowLeftArrowRight", {
  enumerable: true,
  get: function () {
    return _arrowLeftArrowRight.default;
  }
});
Object.defineProperty(exports, "arrowLeftFromBase", {
  enumerable: true,
  get: function () {
    return _arrowLeftFromBase.default;
  }
});
Object.defineProperty(exports, "arrowLeftRight", {
  enumerable: true,
  get: function () {
    return _arrowLeftRight.default;
  }
});
Object.defineProperty(exports, "arrowLeftToBase", {
  enumerable: true,
  get: function () {
    return _arrowLeftToBase.default;
  }
});
Object.defineProperty(exports, "arrowLeftToLine", {
  enumerable: true,
  get: function () {
    return _arrowLeftToLine.default;
  }
});
Object.defineProperty(exports, "arrowLevelDown", {
  enumerable: true,
  get: function () {
    return _arrowLevelDown.default;
  }
});
Object.defineProperty(exports, "arrowLevelUp", {
  enumerable: true,
  get: function () {
    return _arrowLevelUp.default;
  }
});
Object.defineProperty(exports, "arrowOnPath", {
  enumerable: true,
  get: function () {
    return _arrowOnPath.default;
  }
});
Object.defineProperty(exports, "arrowPairSquarepath", {
  enumerable: true,
  get: function () {
    return _arrowPairSquarepath.default;
  }
});
Object.defineProperty(exports, "arrowRight", {
  enumerable: true,
  get: function () {
    return _arrowRight.default;
  }
});
Object.defineProperty(exports, "arrowRightFromBase", {
  enumerable: true,
  get: function () {
    return _arrowRightFromBase.default;
  }
});
Object.defineProperty(exports, "arrowRightToBase", {
  enumerable: true,
  get: function () {
    return _arrowRightToBase.default;
  }
});
Object.defineProperty(exports, "arrowRightToLine", {
  enumerable: true,
  get: function () {
    return _arrowRightToLine.default;
  }
});
Object.defineProperty(exports, "arrowUTurnBackwards", {
  enumerable: true,
  get: function () {
    return _arrowUTurnBackwards.default;
  }
});
Object.defineProperty(exports, "arrowUTurnForwards", {
  enumerable: true,
  get: function () {
    return _arrowUTurnForwards.default;
  }
});
Object.defineProperty(exports, "arrowUp", {
  enumerable: true,
  get: function () {
    return _arrowUp.default;
  }
});
Object.defineProperty(exports, "arrowUpArrowDown", {
  enumerable: true,
  get: function () {
    return _arrowUpArrowDown.default;
  }
});
Object.defineProperty(exports, "arrowUpBackwards", {
  enumerable: true,
  get: function () {
    return _arrowUpBackwards.default;
  }
});
Object.defineProperty(exports, "arrowUpDown", {
  enumerable: true,
  get: function () {
    return _arrowUpDown.default;
  }
});
Object.defineProperty(exports, "arrowUpForwards", {
  enumerable: true,
  get: function () {
    return _arrowUpForwards.default;
  }
});
Object.defineProperty(exports, "arrowUpFromBase", {
  enumerable: true,
  get: function () {
    return _arrowUpFromBase.default;
  }
});
Object.defineProperty(exports, "arrowUpToBase", {
  enumerable: true,
  get: function () {
    return _arrowUpToBase.default;
  }
});
Object.defineProperty(exports, "arrowUpToLine", {
  enumerable: true,
  get: function () {
    return _arrowUpToLine.default;
  }
});
Object.defineProperty(exports, "arrowsInward", {
  enumerable: true,
  get: function () {
    return _arrowsInward.default;
  }
});
Object.defineProperty(exports, "atm", {
  enumerable: true,
  get: function () {
    return _atm.default;
  }
});
Object.defineProperty(exports, "babyBottle", {
  enumerable: true,
  get: function () {
    return _babyBottle.default;
  }
});
Object.defineProperty(exports, "babyStroller", {
  enumerable: true,
  get: function () {
    return _babyStroller.default;
  }
});
Object.defineProperty(exports, "backwardEnd", {
  enumerable: true,
  get: function () {
    return _backwardEnd.default;
  }
});
Object.defineProperty(exports, "bandAid", {
  enumerable: true,
  get: function () {
    return _bandAid.default;
  }
});
Object.defineProperty(exports, "barChartDowntrend", {
  enumerable: true,
  get: function () {
    return _barChartDowntrend.default;
  }
});
Object.defineProperty(exports, "barChartUptrend", {
  enumerable: true,
  get: function () {
    return _barChartUptrend.default;
  }
});
Object.defineProperty(exports, "battery0", {
  enumerable: true,
  get: function () {
    return _battery.default;
  }
});
Object.defineProperty(exports, "battery100", {
  enumerable: true,
  get: function () {
    return _battery2.default;
  }
});
Object.defineProperty(exports, "battery25", {
  enumerable: true,
  get: function () {
    return _battery3.default;
  }
});
Object.defineProperty(exports, "battery50", {
  enumerable: true,
  get: function () {
    return _battery4.default;
  }
});
Object.defineProperty(exports, "battery75", {
  enumerable: true,
  get: function () {
    return _battery5.default;
  }
});
Object.defineProperty(exports, "batteryCharging", {
  enumerable: true,
  get: function () {
    return _batteryCharging.default;
  }
});
Object.defineProperty(exports, "beamAngle", {
  enumerable: true,
  get: function () {
    return _beamAngle.default;
  }
});
Object.defineProperty(exports, "beef", {
  enumerable: true,
  get: function () {
    return _beef.default;
  }
});
Object.defineProperty(exports, "bell", {
  enumerable: true,
  get: function () {
    return _bell.default;
  }
});
Object.defineProperty(exports, "bike", {
  enumerable: true,
  get: function () {
    return _bike.default;
  }
});
Object.defineProperty(exports, "blockOut", {
  enumerable: true,
  get: function () {
    return _blockOut.default;
  }
});
Object.defineProperty(exports, "bookmark", {
  enumerable: true,
  get: function () {
    return _bookmark.default;
  }
});
Object.defineProperty(exports, "box", {
  enumerable: true,
  get: function () {
    return _box.default;
  }
});
Object.defineProperty(exports, "boxCancel", {
  enumerable: true,
  get: function () {
    return _boxCancel.default;
  }
});
Object.defineProperty(exports, "boxExchange", {
  enumerable: true,
  get: function () {
    return _boxExchange.default;
  }
});
Object.defineProperty(exports, "boxExpress", {
  enumerable: true,
  get: function () {
    return _boxExpress.default;
  }
});
Object.defineProperty(exports, "boxRepeat", {
  enumerable: true,
  get: function () {
    return _boxRepeat.default;
  }
});
Object.defineProperty(exports, "boxReturn", {
  enumerable: true,
  get: function () {
    return _boxReturn.default;
  }
});
Object.defineProperty(exports, "briefcase", {
  enumerable: true,
  get: function () {
    return _briefcase.default;
  }
});
Object.defineProperty(exports, "briefcaseCheckmark", {
  enumerable: true,
  get: function () {
    return _briefcaseCheckmark.default;
  }
});
Object.defineProperty(exports, "brightnessDown", {
  enumerable: true,
  get: function () {
    return _brightnessDown.default;
  }
});
Object.defineProperty(exports, "brightnessUp", {
  enumerable: true,
  get: function () {
    return _brightnessUp.default;
  }
});
Object.defineProperty(exports, "bucket", {
  enumerable: true,
  get: function () {
    return _bucket.default;
  }
});
Object.defineProperty(exports, "bulldozer", {
  enumerable: true,
  get: function () {
    return _bulldozer.default;
  }
});
Object.defineProperty(exports, "bullet", {
  enumerable: true,
  get: function () {
    return _bullet.default;
  }
});
Object.defineProperty(exports, "calendar", {
  enumerable: true,
  get: function () {
    return _calendar2.default;
  }
});
Object.defineProperty(exports, "calendar90", {
  enumerable: true,
  get: function () {
    return _calendar.default;
  }
});
Object.defineProperty(exports, "camera", {
  enumerable: true,
  get: function () {
    return _camera.default;
  }
});
Object.defineProperty(exports, "candleLight1800", {
  enumerable: true,
  get: function () {
    return _candleLight.default;
  }
});
Object.defineProperty(exports, "car", {
  enumerable: true,
  get: function () {
    return _car.default;
  }
});
Object.defineProperty(exports, "carElectric", {
  enumerable: true,
  get: function () {
    return _carElectric.default;
  }
});
Object.defineProperty(exports, "carFittingBold", {
  enumerable: true,
  get: function () {
    return _carFittingBold.default;
  }
});
Object.defineProperty(exports, "cargoBike", {
  enumerable: true,
  get: function () {
    return _cargoBike.default;
  }
});
Object.defineProperty(exports, "carton", {
  enumerable: true,
  get: function () {
    return _carton.default;
  }
});
Object.defineProperty(exports, "certificate", {
  enumerable: true,
  get: function () {
    return _certificate.default;
  }
});
Object.defineProperty(exports, "charging", {
  enumerable: true,
  get: function () {
    return _charging.default;
  }
});
Object.defineProperty(exports, "chat", {
  enumerable: true,
  get: function () {
    return _chat.default;
  }
});
Object.defineProperty(exports, "checkmark", {
  enumerable: true,
  get: function () {
    return _checkmark.default;
  }
});
Object.defineProperty(exports, "checkmarkBox", {
  enumerable: true,
  get: function () {
    return _checkmarkBox.default;
  }
});
Object.defineProperty(exports, "checkmarkCircle", {
  enumerable: true,
  get: function () {
    return _checkmarkCircle.default;
  }
});
Object.defineProperty(exports, "checkmarkSmall", {
  enumerable: true,
  get: function () {
    return _checkmarkSmall.default;
  }
});
Object.defineProperty(exports, "chevronDoubleDown", {
  enumerable: true,
  get: function () {
    return _chevronDoubleDown.default;
  }
});
Object.defineProperty(exports, "chevronDoubleDownSmall", {
  enumerable: true,
  get: function () {
    return _chevronDoubleDownSmall.default;
  }
});
Object.defineProperty(exports, "chevronDoubleLeft", {
  enumerable: true,
  get: function () {
    return _chevronDoubleLeft.default;
  }
});
Object.defineProperty(exports, "chevronDoubleLeftSmall", {
  enumerable: true,
  get: function () {
    return _chevronDoubleLeftSmall.default;
  }
});
Object.defineProperty(exports, "chevronDoubleRight", {
  enumerable: true,
  get: function () {
    return _chevronDoubleRight.default;
  }
});
Object.defineProperty(exports, "chevronDoubleRightSmall", {
  enumerable: true,
  get: function () {
    return _chevronDoubleRightSmall.default;
  }
});
Object.defineProperty(exports, "chevronDoubleUp", {
  enumerable: true,
  get: function () {
    return _chevronDoubleUp.default;
  }
});
Object.defineProperty(exports, "chevronDoubleUpSmall", {
  enumerable: true,
  get: function () {
    return _chevronDoubleUpSmall.default;
  }
});
Object.defineProperty(exports, "chevronDown", {
  enumerable: true,
  get: function () {
    return _chevronDown.default;
  }
});
Object.defineProperty(exports, "chevronDownSmall", {
  enumerable: true,
  get: function () {
    return _chevronDownSmall.default;
  }
});
Object.defineProperty(exports, "chevronLeft", {
  enumerable: true,
  get: function () {
    return _chevronLeft.default;
  }
});
Object.defineProperty(exports, "chevronLeftSlashChevronRight", {
  enumerable: true,
  get: function () {
    return _chevronLeftSlashChevronRight.default;
  }
});
Object.defineProperty(exports, "chevronLeftSmall", {
  enumerable: true,
  get: function () {
    return _chevronLeftSmall.default;
  }
});
Object.defineProperty(exports, "chevronRight", {
  enumerable: true,
  get: function () {
    return _chevronRight.default;
  }
});
Object.defineProperty(exports, "chevronRightSmall", {
  enumerable: true,
  get: function () {
    return _chevronRightSmall.default;
  }
});
Object.defineProperty(exports, "chevronUp", {
  enumerable: true,
  get: function () {
    return _chevronUp.default;
  }
});
Object.defineProperty(exports, "chevronUpChevronDown", {
  enumerable: true,
  get: function () {
    return _chevronUpChevronDown.default;
  }
});
Object.defineProperty(exports, "chevronUpChevronDownSmall", {
  enumerable: true,
  get: function () {
    return _chevronUpChevronDownSmall.default;
  }
});
Object.defineProperty(exports, "chevronUpSmall", {
  enumerable: true,
  get: function () {
    return _chevronUpSmall.default;
  }
});
Object.defineProperty(exports, "chicken", {
  enumerable: true,
  get: function () {
    return _chicken.default;
  }
});
Object.defineProperty(exports, "circle", {
  enumerable: true,
  get: function () {
    return _circle.default;
  }
});
Object.defineProperty(exports, "circleFilled", {
  enumerable: true,
  get: function () {
    return _circleFilled.default;
  }
});
Object.defineProperty(exports, "circleFourSegments", {
  enumerable: true,
  get: function () {
    return _circleFourSegments.default;
  }
});
Object.defineProperty(exports, "circleFourSegmentsFilled", {
  enumerable: true,
  get: function () {
    return _circleFourSegmentsFilled.default;
  }
});
Object.defineProperty(exports, "circleHalf", {
  enumerable: true,
  get: function () {
    return _circleHalf.default;
  }
});
Object.defineProperty(exports, "circleThreeSegments", {
  enumerable: true,
  get: function () {
    return _circleThreeSegments.default;
  }
});
Object.defineProperty(exports, "circleThreeSegmentsFilled", {
  enumerable: true,
  get: function () {
    return _circleThreeSegmentsFilled.default;
  }
});
Object.defineProperty(exports, "circlepathThreeTriangles", {
  enumerable: true,
  get: function () {
    return _circlepathThreeTriangles.default;
  }
});
Object.defineProperty(exports, "circlepathTwoTriangles", {
  enumerable: true,
  get: function () {
    return _circlepathTwoTriangles.default;
  }
});
Object.defineProperty(exports, "cleanSparkles", {
  enumerable: true,
  get: function () {
    return _cleanSparkles.default;
  }
});
Object.defineProperty(exports, "clickAndCollect", {
  enumerable: true,
  get: function () {
    return _clickAndCollect.default;
  }
});
Object.defineProperty(exports, "clickAndCollectStrikethrough", {
  enumerable: true,
  get: function () {
    return _clickAndCollectStrikethrough.default;
  }
});
Object.defineProperty(exports, "clipboard", {
  enumerable: true,
  get: function () {
    return _clipboard.default;
  }
});
Object.defineProperty(exports, "clipboardCheckmark", {
  enumerable: true,
  get: function () {
    return _clipboardCheckmark.default;
  }
});
Object.defineProperty(exports, "clipboardStrikethrough", {
  enumerable: true,
  get: function () {
    return _clipboardStrikethrough.default;
  }
});
Object.defineProperty(exports, "clock", {
  enumerable: true,
  get: function () {
    return _clock.default;
  }
});
Object.defineProperty(exports, "coatHanger", {
  enumerable: true,
  get: function () {
    return _coatHanger.default;
  }
});
Object.defineProperty(exports, "coffeeWaste", {
  enumerable: true,
  get: function () {
    return _coffeeWaste.default;
  }
});
Object.defineProperty(exports, "coldDrink", {
  enumerable: true,
  get: function () {
    return _coldDrink.default;
  }
});
Object.defineProperty(exports, "coldDrinkContents", {
  enumerable: true,
  get: function () {
    return _coldDrinkContents.default;
  }
});
Object.defineProperty(exports, "colourFan", {
  enumerable: true,
  get: function () {
    return _colourFan.default;
  }
});
Object.defineProperty(exports, "colourSpectrum", {
  enumerable: true,
  get: function () {
    return _colourSpectrum.default;
  }
});
Object.defineProperty(exports, "community", {
  enumerable: true,
  get: function () {
    return _community.default;
  }
});
Object.defineProperty(exports, "contactlessPayment", {
  enumerable: true,
  get: function () {
    return _contactlessPayment.default;
  }
});
Object.defineProperty(exports, "contract", {
  enumerable: true,
  get: function () {
    return _contract.default;
  }
});
Object.defineProperty(exports, "coolDaylight5000", {
  enumerable: true,
  get: function () {
    return _coolDaylight.default;
  }
});
Object.defineProperty(exports, "coolDaylight5200", {
  enumerable: true,
  get: function () {
    return _coolDaylight2.default;
  }
});
Object.defineProperty(exports, "coolSky6000", {
  enumerable: true,
  get: function () {
    return _coolSky.default;
  }
});
Object.defineProperty(exports, "coolWhite4000", {
  enumerable: true,
  get: function () {
    return _coolWhite.default;
  }
});
Object.defineProperty(exports, "cooling", {
  enumerable: true,
  get: function () {
    return _cooling.default;
  }
});
Object.defineProperty(exports, "copy", {
  enumerable: true,
  get: function () {
    return _copy.default;
  }
});
Object.defineProperty(exports, "coupon", {
  enumerable: true,
  get: function () {
    return _coupon.default;
  }
});
Object.defineProperty(exports, "createNew", {
  enumerable: true,
  get: function () {
    return _createNew.default;
  }
});
Object.defineProperty(exports, "creditCard", {
  enumerable: true,
  get: function () {
    return _creditCard.default;
  }
});
Object.defineProperty(exports, "cross", {
  enumerable: true,
  get: function () {
    return _cross.default;
  }
});
Object.defineProperty(exports, "crossBox", {
  enumerable: true,
  get: function () {
    return _crossBox.default;
  }
});
Object.defineProperty(exports, "crossCircle", {
  enumerable: true,
  get: function () {
    return _crossCircle.default;
  }
});
Object.defineProperty(exports, "crossSmall", {
  enumerable: true,
  get: function () {
    return _crossSmall.default;
  }
});
Object.defineProperty(exports, "crosshair", {
  enumerable: true,
  get: function () {
    return _crosshair.default;
  }
});
Object.defineProperty(exports, "cube3d", {
  enumerable: true,
  get: function () {
    return _cube3d.default;
  }
});
Object.defineProperty(exports, "cube3dFrontFilled", {
  enumerable: true,
  get: function () {
    return _cube3dFrontFilled.default;
  }
});
Object.defineProperty(exports, "cube3dTopFilled", {
  enumerable: true,
  get: function () {
    return _cube3dTopFilled.default;
  }
});
Object.defineProperty(exports, "cup", {
  enumerable: true,
  get: function () {
    return _cup.default;
  }
});
Object.defineProperty(exports, "cupFilled", {
  enumerable: true,
  get: function () {
    return _cupFilled.default;
  }
});
Object.defineProperty(exports, "customerService", {
  enumerable: true,
  get: function () {
    return _customerService.default;
  }
});
Object.defineProperty(exports, "cutlery", {
  enumerable: true,
  get: function () {
    return _cutlery.default;
  }
});
Object.defineProperty(exports, "dataChart", {
  enumerable: true,
  get: function () {
    return _dataChart.default;
  }
});
Object.defineProperty(exports, "deliveryTruck", {
  enumerable: true,
  get: function () {
    return _deliveryTruck.default;
  }
});
Object.defineProperty(exports, "deliveryTruckStrikethrough", {
  enumerable: true,
  get: function () {
    return _deliveryTruckStrikethrough.default;
  }
});
Object.defineProperty(exports, "dimmable", {
  enumerable: true,
  get: function () {
    return _dimmable.default;
  }
});
Object.defineProperty(exports, "dirt", {
  enumerable: true,
  get: function () {
    return _dirt.default;
  }
});
Object.defineProperty(exports, "discountTag", {
  enumerable: true,
  get: function () {
    return _discountTag.default;
  }
});
Object.defineProperty(exports, "display", {
  enumerable: true,
  get: function () {
    return _display.default;
  }
});
Object.defineProperty(exports, "document", {
  enumerable: true,
  get: function () {
    return _document.default;
  }
});
Object.defineProperty(exports, "documentAdd", {
  enumerable: true,
  get: function () {
    return _documentAdd.default;
  }
});
Object.defineProperty(exports, "documentAlert", {
  enumerable: true,
  get: function () {
    return _documentAlert.default;
  }
});
Object.defineProperty(exports, "documentCheckmark", {
  enumerable: true,
  get: function () {
    return _documentCheckmark.default;
  }
});
Object.defineProperty(exports, "documentFinancial", {
  enumerable: true,
  get: function () {
    return _documentFinancial.default;
  }
});
Object.defineProperty(exports, "documentList", {
  enumerable: true,
  get: function () {
    return _documentList.default;
  }
});
Object.defineProperty(exports, "documentMagnifyingGlass", {
  enumerable: true,
  get: function () {
    return _documentMagnifyingGlass.default;
  }
});
Object.defineProperty(exports, "documentPencil", {
  enumerable: true,
  get: function () {
    return _documentPencil.default;
  }
});
Object.defineProperty(exports, "documentUpload", {
  enumerable: true,
  get: function () {
    return _documentUpload.default;
  }
});
Object.defineProperty(exports, "dog", {
  enumerable: true,
  get: function () {
    return _dog.default;
  }
});
Object.defineProperty(exports, "drill", {
  enumerable: true,
  get: function () {
    return _drill.default;
  }
});
Object.defineProperty(exports, "ear", {
  enumerable: true,
  get: function () {
    return _ear.default;
  }
});
Object.defineProperty(exports, "earStrikethrough", {
  enumerable: true,
  get: function () {
    return _earStrikethrough.default;
  }
});
Object.defineProperty(exports, "egg", {
  enumerable: true,
  get: function () {
    return _egg.default;
  }
});
Object.defineProperty(exports, "eggStrikethrough", {
  enumerable: true,
  get: function () {
    return _eggStrikethrough.default;
  }
});
Object.defineProperty(exports, "electronicCircle", {
  enumerable: true,
  get: function () {
    return _electronicCircle.default;
  }
});
Object.defineProperty(exports, "ellipsesHorizontal", {
  enumerable: true,
  get: function () {
    return _ellipsesHorizontal.default;
  }
});
Object.defineProperty(exports, "ellipsesVertical", {
  enumerable: true,
  get: function () {
    return _ellipsesVertical.default;
  }
});
Object.defineProperty(exports, "ellipsis", {
  enumerable: true,
  get: function () {
    return _ellipsis.default;
  }
});
Object.defineProperty(exports, "escalatorDown", {
  enumerable: true,
  get: function () {
    return _escalatorDown.default;
  }
});
Object.defineProperty(exports, "escalatorUp", {
  enumerable: true,
  get: function () {
    return _escalatorUp.default;
  }
});
Object.defineProperty(exports, "escalatorUpDown", {
  enumerable: true,
  get: function () {
    return _escalatorUpDown.default;
  }
});
Object.defineProperty(exports, "expand", {
  enumerable: true,
  get: function () {
    return _expand.default;
  }
});
Object.defineProperty(exports, "fabric", {
  enumerable: true,
  get: function () {
    return _fabric.default;
  }
});
Object.defineProperty(exports, "facebook", {
  enumerable: true,
  get: function () {
    return _facebook.default;
  }
});
Object.defineProperty(exports, "facebookColour", {
  enumerable: true,
  get: function () {
    return _facebookColour.default;
  }
});
Object.defineProperty(exports, "factory", {
  enumerable: true,
  get: function () {
    return _factory.default;
  }
});
Object.defineProperty(exports, "fallingBoxes", {
  enumerable: true,
  get: function () {
    return _fallingBoxes.default;
  }
});
Object.defineProperty(exports, "familyGenderMen", {
  enumerable: true,
  get: function () {
    return _familyGenderMen.default;
  }
});
Object.defineProperty(exports, "familyGenderMixed", {
  enumerable: true,
  get: function () {
    return _familyGenderMixed.default;
  }
});
Object.defineProperty(exports, "familyGenderWomen", {
  enumerable: true,
  get: function () {
    return _familyGenderWomen.default;
  }
});
Object.defineProperty(exports, "fan", {
  enumerable: true,
  get: function () {
    return _fan.default;
  }
});
Object.defineProperty(exports, "fastForward", {
  enumerable: true,
  get: function () {
    return _fastForward.default;
  }
});
Object.defineProperty(exports, "fauxLeather", {
  enumerable: true,
  get: function () {
    return _fauxLeather.default;
  }
});
Object.defineProperty(exports, "feedbackDissatisfied", {
  enumerable: true,
  get: function () {
    return _feedbackDissatisfied.default;
  }
});
Object.defineProperty(exports, "feedbackHappy", {
  enumerable: true,
  get: function () {
    return _feedbackHappy.default;
  }
});
Object.defineProperty(exports, "feedbackNeutral", {
  enumerable: true,
  get: function () {
    return _feedbackNeutral.default;
  }
});
Object.defineProperty(exports, "feedbackSad", {
  enumerable: true,
  get: function () {
    return _feedbackSad.default;
  }
});
Object.defineProperty(exports, "feedbackSatisfied", {
  enumerable: true,
  get: function () {
    return _feedbackSatisfied.default;
  }
});
Object.defineProperty(exports, "filters", {
  enumerable: true,
  get: function () {
    return _filters.default;
  }
});
Object.defineProperty(exports, "financing", {
  enumerable: true,
  get: function () {
    return _financing.default;
  }
});
Object.defineProperty(exports, "firstAidRoomCrescent", {
  enumerable: true,
  get: function () {
    return _firstAidRoomCrescent.default;
  }
});
Object.defineProperty(exports, "firstAidRoomCross", {
  enumerable: true,
  get: function () {
    return _firstAidRoomCross.default;
  }
});
Object.defineProperty(exports, "fish", {
  enumerable: true,
  get: function () {
    return _fish.default;
  }
});
Object.defineProperty(exports, "flag", {
  enumerable: true,
  get: function () {
    return _flag.default;
  }
});
Object.defineProperty(exports, "flame", {
  enumerable: true,
  get: function () {
    return _flame.default;
  }
});
Object.defineProperty(exports, "fluorescentLamp", {
  enumerable: true,
  get: function () {
    return _fluorescentLamp.default;
  }
});
Object.defineProperty(exports, "folder", {
  enumerable: true,
  get: function () {
    return _folder.default;
  }
});
Object.defineProperty(exports, "footprint", {
  enumerable: true,
  get: function () {
    return _footprint.default;
  }
});
Object.defineProperty(exports, "forwardEnd", {
  enumerable: true,
  get: function () {
    return _forwardEnd.default;
  }
});
Object.defineProperty(exports, "fullScreen", {
  enumerable: true,
  get: function () {
    return _fullScreen.default;
  }
});
Object.defineProperty(exports, "fullscreen", {
  enumerable: true,
  get: function () {
    return _fullscreen.default;
  }
});
Object.defineProperty(exports, "furnitureTrolley", {
  enumerable: true,
  get: function () {
    return _furnitureTrolley.default;
  }
});
Object.defineProperty(exports, "furnitureTrolleyLoaded", {
  enumerable: true,
  get: function () {
    return _furnitureTrolleyLoaded.default;
  }
});
Object.defineProperty(exports, "garbageTruck", {
  enumerable: true,
  get: function () {
    return _garbageTruck.default;
  }
});
Object.defineProperty(exports, "gear", {
  enumerable: true,
  get: function () {
    return _gear.default;
  }
});
Object.defineProperty(exports, "giftBag", {
  enumerable: true,
  get: function () {
    return _giftBag.default;
  }
});
Object.defineProperty(exports, "giftBagActive", {
  enumerable: true,
  get: function () {
    return _giftBagActive.default;
  }
});
Object.defineProperty(exports, "giftBagAdd", {
  enumerable: true,
  get: function () {
    return _giftBagAdd.default;
  }
});
Object.defineProperty(exports, "giftBox", {
  enumerable: true,
  get: function () {
    return _giftBox.default;
  }
});
Object.defineProperty(exports, "giftBoxActive", {
  enumerable: true,
  get: function () {
    return _giftBoxActive.default;
  }
});
Object.defineProperty(exports, "giftBoxFilled", {
  enumerable: true,
  get: function () {
    return _giftBoxFilled.default;
  }
});
Object.defineProperty(exports, "giftCard", {
  enumerable: true,
  get: function () {
    return _giftCard.default;
  }
});
Object.defineProperty(exports, "globe", {
  enumerable: true,
  get: function () {
    return _globe.default;
  }
});
Object.defineProperty(exports, "guarantee10", {
  enumerable: true,
  get: function () {
    return _guarantee.default;
  }
});
Object.defineProperty(exports, "guarantee15", {
  enumerable: true,
  get: function () {
    return _guarantee2.default;
  }
});
Object.defineProperty(exports, "guarantee2", {
  enumerable: true,
  get: function () {
    return _guarantee3.default;
  }
});
Object.defineProperty(exports, "guarantee25", {
  enumerable: true,
  get: function () {
    return _guarantee4.default;
  }
});
Object.defineProperty(exports, "guarantee3", {
  enumerable: true,
  get: function () {
    return _guarantee5.default;
  }
});
Object.defineProperty(exports, "guarantee5", {
  enumerable: true,
  get: function () {
    return _guarantee6.default;
  }
});
Object.defineProperty(exports, "hand", {
  enumerable: true,
  get: function () {
    return _hand.default;
  }
});
Object.defineProperty(exports, "handGestures", {
  enumerable: true,
  get: function () {
    return _handGestures.default;
  }
});
Object.defineProperty(exports, "handMove", {
  enumerable: true,
  get: function () {
    return _handMove.default;
  }
});
Object.defineProperty(exports, "handPoint", {
  enumerable: true,
  get: function () {
    return _handPoint.default;
  }
});
Object.defineProperty(exports, "handStrikethrough", {
  enumerable: true,
  get: function () {
    return _handStrikethrough.default;
  }
});
Object.defineProperty(exports, "handTouch", {
  enumerable: true,
  get: function () {
    return _handTouch.default;
  }
});
Object.defineProperty(exports, "handWithBag", {
  enumerable: true,
  get: function () {
    return _handWithBag.default;
  }
});
Object.defineProperty(exports, "handWithBox", {
  enumerable: true,
  get: function () {
    return _handWithBox.default;
  }
});
Object.defineProperty(exports, "handWithDiscount", {
  enumerable: true,
  get: function () {
    return _handWithDiscount.default;
  }
});
Object.defineProperty(exports, "handWithDrop", {
  enumerable: true,
  get: function () {
    return _handWithDrop.default;
  }
});
Object.defineProperty(exports, "handWithDrops", {
  enumerable: true,
  get: function () {
    return _handWithDrops.default;
  }
});
Object.defineProperty(exports, "handWithHeart", {
  enumerable: true,
  get: function () {
    return _handWithHeart.default;
  }
});
Object.defineProperty(exports, "handWithKey", {
  enumerable: true,
  get: function () {
    return _handWithKey.default;
  }
});
Object.defineProperty(exports, "handWithPlate", {
  enumerable: true,
  get: function () {
    return _handWithPlate.default;
  }
});
Object.defineProperty(exports, "handWithSparkles", {
  enumerable: true,
  get: function () {
    return _handWithSparkles.default;
  }
});
Object.defineProperty(exports, "handle", {
  enumerable: true,
  get: function () {
    return _handle.default;
  }
});
Object.defineProperty(exports, "heart", {
  enumerable: true,
  get: function () {
    return _heart.default;
  }
});
Object.defineProperty(exports, "heartFilled", {
  enumerable: true,
  get: function () {
    return _heartFilled.default;
  }
});
Object.defineProperty(exports, "heatPump", {
  enumerable: true,
  get: function () {
    return _heatPump.default;
  }
});
Object.defineProperty(exports, "history", {
  enumerable: true,
  get: function () {
    return _history.default;
  }
});
Object.defineProperty(exports, "home", {
  enumerable: true,
  get: function () {
    return _home.default;
  }
});
Object.defineProperty(exports, "hotDog", {
  enumerable: true,
  get: function () {
    return _hotDog.default;
  }
});
Object.defineProperty(exports, "hotDrink", {
  enumerable: true,
  get: function () {
    return _hotDrink.default;
  }
});
Object.defineProperty(exports, "iceCream", {
  enumerable: true,
  get: function () {
    return _iceCream.default;
  }
});
Object.defineProperty(exports, "id", {
  enumerable: true,
  get: function () {
    return _id.default;
  }
});
Object.defineProperty(exports, "image", {
  enumerable: true,
  get: function () {
    return _image.default;
  }
});
Object.defineProperty(exports, "imageStack", {
  enumerable: true,
  get: function () {
    return _imageStack.default;
  }
});
Object.defineProperty(exports, "imageStrikethrough", {
  enumerable: true,
  get: function () {
    return _imageStrikethrough.default;
  }
});
Object.defineProperty(exports, "incorrect", {
  enumerable: true,
  get: function () {
    return _incorrect.default;
  }
});
Object.defineProperty(exports, "information", {
  enumerable: true,
  get: function () {
    return _information.default;
  }
});
Object.defineProperty(exports, "informationCircle", {
  enumerable: true,
  get: function () {
    return _informationCircle.default;
  }
});
Object.defineProperty(exports, "instagram", {
  enumerable: true,
  get: function () {
    return _instagram.default;
  }
});
Object.defineProperty(exports, "instagramColour", {
  enumerable: true,
  get: function () {
    return _instagramColour.default;
  }
});
Object.defineProperty(exports, "institution", {
  enumerable: true,
  get: function () {
    return _institution.default;
  }
});
Object.defineProperty(exports, "inverter", {
  enumerable: true,
  get: function () {
    return _inverter.default;
  }
});
Object.defineProperty(exports, "kakaoTalk", {
  enumerable: true,
  get: function () {
    return _kakaoTalk.default;
  }
});
Object.defineProperty(exports, "kakaoTalkColour", {
  enumerable: true,
  get: function () {
    return _kakaoTalkColour.default;
  }
});
Object.defineProperty(exports, "kickScooter", {
  enumerable: true,
  get: function () {
    return _kickScooter.default;
  }
});
Object.defineProperty(exports, "lamb", {
  enumerable: true,
  get: function () {
    return _lamb.default;
  }
});
Object.defineProperty(exports, "laptop", {
  enumerable: true,
  get: function () {
    return _laptop.default;
  }
});
Object.defineProperty(exports, "laptopCheckmark", {
  enumerable: true,
  get: function () {
    return _laptopCheckmark.default;
  }
});
Object.defineProperty(exports, "laptopMagnifyingGlass", {
  enumerable: true,
  get: function () {
    return _laptopMagnifyingGlass.default;
  }
});
Object.defineProperty(exports, "laptopPencil", {
  enumerable: true,
  get: function () {
    return _laptopPencil.default;
  }
});
Object.defineProperty(exports, "layout", {
  enumerable: true,
  get: function () {
    return _layout.default;
  }
});
Object.defineProperty(exports, "layoutAlternative", {
  enumerable: true,
  get: function () {
    return _layoutAlternative.default;
  }
});
Object.defineProperty(exports, "leaf", {
  enumerable: true,
  get: function () {
    return _leaf.default;
  }
});
Object.defineProperty(exports, "leather", {
  enumerable: true,
  get: function () {
    return _leather.default;
  }
});
Object.defineProperty(exports, "leatherAndFauxLeather", {
  enumerable: true,
  get: function () {
    return _leatherAndFauxLeather.default;
  }
});
Object.defineProperty(exports, "liftDown", {
  enumerable: true,
  get: function () {
    return _liftDown.default;
  }
});
Object.defineProperty(exports, "liftFurnitureTrolley", {
  enumerable: true,
  get: function () {
    return _liftFurnitureTrolley.default;
  }
});
Object.defineProperty(exports, "liftShoppingTrolley", {
  enumerable: true,
  get: function () {
    return _liftShoppingTrolley.default;
  }
});
Object.defineProperty(exports, "liftUp", {
  enumerable: true,
  get: function () {
    return _liftUp.default;
  }
});
Object.defineProperty(exports, "liftUpDown", {
  enumerable: true,
  get: function () {
    return _liftUpDown.default;
  }
});
Object.defineProperty(exports, "lightFiltering", {
  enumerable: true,
  get: function () {
    return _lightFiltering.default;
  }
});
Object.defineProperty(exports, "lightbulbIncandescent", {
  enumerable: true,
  get: function () {
    return _lightbulbIncandescent.default;
  }
});
Object.defineProperty(exports, "lightbulbLed", {
  enumerable: true,
  get: function () {
    return _lightbulbLed.default;
  }
});
Object.defineProperty(exports, "lightbulbLedAlternative", {
  enumerable: true,
  get: function () {
    return _lightbulbLedAlternative.default;
  }
});
Object.defineProperty(exports, "lightbulbWithRays", {
  enumerable: true,
  get: function () {
    return _lightbulbWithRays.default;
  }
});
Object.defineProperty(exports, "line", {
  enumerable: true,
  get: function () {
    return _line.default;
  }
});
Object.defineProperty(exports, "lineColour", {
  enumerable: true,
  get: function () {
    return _lineColour.default;
  }
});
Object.defineProperty(exports, "link", {
  enumerable: true,
  get: function () {
    return _link.default;
  }
});
Object.defineProperty(exports, "linkOut", {
  enumerable: true,
  get: function () {
    return _linkOut.default;
  }
});
Object.defineProperty(exports, "linkedin", {
  enumerable: true,
  get: function () {
    return _linkedin.default;
  }
});
Object.defineProperty(exports, "linkedinColour", {
  enumerable: true,
  get: function () {
    return _linkedinColour.default;
  }
});
Object.defineProperty(exports, "list", {
  enumerable: true,
  get: function () {
    return _list.default;
  }
});
Object.defineProperty(exports, "liveVideo", {
  enumerable: true,
  get: function () {
    return _liveVideo.default;
  }
});
Object.defineProperty(exports, "locationPin", {
  enumerable: true,
  get: function () {
    return _locationPin.default;
  }
});
Object.defineProperty(exports, "locationPinFilled", {
  enumerable: true,
  get: function () {
    return _locationPinFilled.default;
  }
});
Object.defineProperty(exports, "locationPinSmall", {
  enumerable: true,
  get: function () {
    return _locationPinSmall.default;
  }
});
Object.defineProperty(exports, "locationPinSmallFilled", {
  enumerable: true,
  get: function () {
    return _locationPinSmallFilled.default;
  }
});
Object.defineProperty(exports, "locationPointer", {
  enumerable: true,
  get: function () {
    return _locationPointer.default;
  }
});
Object.defineProperty(exports, "lock", {
  enumerable: true,
  get: function () {
    return _lock.default;
  }
});
Object.defineProperty(exports, "lockOpen", {
  enumerable: true,
  get: function () {
    return _lockOpen.default;
  }
});
Object.defineProperty(exports, "lockers", {
  enumerable: true,
  get: function () {
    return _lockers.default;
  }
});
Object.defineProperty(exports, "magnifyingGlass", {
  enumerable: true,
  get: function () {
    return _magnifyingGlass.default;
  }
});
Object.defineProperty(exports, "magnifyingGlassList", {
  enumerable: true,
  get: function () {
    return _magnifyingGlassList.default;
  }
});
Object.defineProperty(exports, "mail", {
  enumerable: true,
  get: function () {
    return _mail.default;
  }
});
Object.defineProperty(exports, "map", {
  enumerable: true,
  get: function () {
    return _map.default;
  }
});
Object.defineProperty(exports, "mattressComfortZones", {
  enumerable: true,
  get: function () {
    return _mattressComfortZones.default;
  }
});
Object.defineProperty(exports, "mattressExtraFirm", {
  enumerable: true,
  get: function () {
    return _mattressExtraFirm.default;
  }
});
Object.defineProperty(exports, "mattressFirm", {
  enumerable: true,
  get: function () {
    return _mattressFirm.default;
  }
});
Object.defineProperty(exports, "mattressFoam", {
  enumerable: true,
  get: function () {
    return _mattressFoam.default;
  }
});
Object.defineProperty(exports, "mattressHybrid", {
  enumerable: true,
  get: function () {
    return _mattressHybrid.default;
  }
});
Object.defineProperty(exports, "mattressLatex", {
  enumerable: true,
  get: function () {
    return _mattressLatex.default;
  }
});
Object.defineProperty(exports, "mattressMaterialNatural", {
  enumerable: true,
  get: function () {
    return _mattressMaterialNatural.default;
  }
});
Object.defineProperty(exports, "mattressMaterialVegan", {
  enumerable: true,
  get: function () {
    return _mattressMaterialVegan.default;
  }
});
Object.defineProperty(exports, "mattressMediumFirm", {
  enumerable: true,
  get: function () {
    return _mattressMediumFirm.default;
  }
});
Object.defineProperty(exports, "mattressMemoryFoam", {
  enumerable: true,
  get: function () {
    return _mattressMemoryFoam.default;
  }
});
Object.defineProperty(exports, "mattressPlush", {
  enumerable: true,
  get: function () {
    return _mattressPlush.default;
  }
});
Object.defineProperty(exports, "mattressRollPacked", {
  enumerable: true,
  get: function () {
    return _mattressRollPacked.default;
  }
});
Object.defineProperty(exports, "mattressSpringsBonnell", {
  enumerable: true,
  get: function () {
    return _mattressSpringsBonnell.default;
  }
});
Object.defineProperty(exports, "mattressSpringsMini", {
  enumerable: true,
  get: function () {
    return _mattressSpringsMini.default;
  }
});
Object.defineProperty(exports, "mattressSpringsPocket", {
  enumerable: true,
  get: function () {
    return _mattressSpringsPocket.default;
  }
});
Object.defineProperty(exports, "mattressTopper", {
  enumerable: true,
  get: function () {
    return _mattressTopper.default;
  }
});
Object.defineProperty(exports, "medic", {
  enumerable: true,
  get: function () {
    return _medic.default;
  }
});
Object.defineProperty(exports, "medicCrescent", {
  enumerable: true,
  get: function () {
    return _medicCrescent.default;
  }
});
Object.defineProperty(exports, "membershipCard", {
  enumerable: true,
  get: function () {
    return _membershipCard.default;
  }
});
Object.defineProperty(exports, "membershipDigitalCard", {
  enumerable: true,
  get: function () {
    return _membershipDigitalCard.default;
  }
});
Object.defineProperty(exports, "menu", {
  enumerable: true,
  get: function () {
    return _menu.default;
  }
});
Object.defineProperty(exports, "microphone", {
  enumerable: true,
  get: function () {
    return _microphone.default;
  }
});
Object.defineProperty(exports, "milkBottle", {
  enumerable: true,
  get: function () {
    return _milkBottle.default;
  }
});
Object.defineProperty(exports, "milkBottleStrikethrough", {
  enumerable: true,
  get: function () {
    return _milkBottleStrikethrough.default;
  }
});
Object.defineProperty(exports, "minus", {
  enumerable: true,
  get: function () {
    return _minus.default;
  }
});
Object.defineProperty(exports, "minusSmall", {
  enumerable: true,
  get: function () {
    return _minusSmall.default;
  }
});
Object.defineProperty(exports, "missing", {
  enumerable: true,
  get: function () {
    return _missing.default;
  }
});
Object.defineProperty(exports, "mobile", {
  enumerable: true,
  get: function () {
    return _mobile.default;
  }
});
Object.defineProperty(exports, "mobileHandover", {
  enumerable: true,
  get: function () {
    return _mobileHandover.default;
  }
});
Object.defineProperty(exports, "moneyBills", {
  enumerable: true,
  get: function () {
    return _moneyBills.default;
  }
});
Object.defineProperty(exports, "moneyCash", {
  enumerable: true,
  get: function () {
    return _moneyCash.default;
  }
});
Object.defineProperty(exports, "moneyCoins", {
  enumerable: true,
  get: function () {
    return _moneyCoins.default;
  }
});
Object.defineProperty(exports, "motionSensor", {
  enumerable: true,
  get: function () {
    return _motionSensor.default;
  }
});
Object.defineProperty(exports, "motorBike", {
  enumerable: true,
  get: function () {
    return _motorBike.default;
  }
});
Object.defineProperty(exports, "network", {
  enumerable: true,
  get: function () {
    return _network.default;
  }
});
Object.defineProperty(exports, "note", {
  enumerable: true,
  get: function () {
    return _note.default;
  }
});
Object.defineProperty(exports, "notice", {
  enumerable: true,
  get: function () {
    return _notice.default;
  }
});
Object.defineProperty(exports, "noticeCircle", {
  enumerable: true,
  get: function () {
    return _noticeCircle.default;
  }
});
Object.defineProperty(exports, "noticeSmall", {
  enumerable: true,
  get: function () {
    return _noticeSmall.default;
  }
});
Object.defineProperty(exports, "odnoklassniki", {
  enumerable: true,
  get: function () {
    return _odnoklassniki.default;
  }
});
Object.defineProperty(exports, "odnoklassnikiColour", {
  enumerable: true,
  get: function () {
    return _odnoklassnikiColour.default;
  }
});
Object.defineProperty(exports, "oilContainer", {
  enumerable: true,
  get: function () {
    return _oilContainer.default;
  }
});
Object.defineProperty(exports, "oval", {
  enumerable: true,
  get: function () {
    return _oval.default;
  }
});
Object.defineProperty(exports, "paintbrush", {
  enumerable: true,
  get: function () {
    return _paintbrush.default;
  }
});
Object.defineProperty(exports, "pairing", {
  enumerable: true,
  get: function () {
    return _pairing.default;
  }
});
Object.defineProperty(exports, "paperTowels", {
  enumerable: true,
  get: function () {
    return _paperTowels.default;
  }
});
Object.defineProperty(exports, "paperclip", {
  enumerable: true,
  get: function () {
    return _paperclip.default;
  }
});
Object.defineProperty(exports, "parking", {
  enumerable: true,
  get: function () {
    return _parking.default;
  }
});
Object.defineProperty(exports, "parkingGarage", {
  enumerable: true,
  get: function () {
    return _parkingGarage.default;
  }
});
Object.defineProperty(exports, "pass", {
  enumerable: true,
  get: function () {
    return _pass.default;
  }
});
Object.defineProperty(exports, "pause", {
  enumerable: true,
  get: function () {
    return _pause.default;
  }
});
Object.defineProperty(exports, "pedestrian", {
  enumerable: true,
  get: function () {
    return _pedestrian.default;
  }
});
Object.defineProperty(exports, "pedestrianWithWalkingStick", {
  enumerable: true,
  get: function () {
    return _pedestrianWithWalkingStick.default;
  }
});
Object.defineProperty(exports, "pencil", {
  enumerable: true,
  get: function () {
    return _pencil.default;
  }
});
Object.defineProperty(exports, "people", {
  enumerable: true,
  get: function () {
    return _people.default;
  }
});
Object.defineProperty(exports, "person", {
  enumerable: true,
  get: function () {
    return _person.default;
  }
});
Object.defineProperty(exports, "personActive", {
  enumerable: true,
  get: function () {
    return _personActive.default;
  }
});
Object.defineProperty(exports, "phone", {
  enumerable: true,
  get: function () {
    return _phone.default;
  }
});
Object.defineProperty(exports, "phonePayment", {
  enumerable: true,
  get: function () {
    return _phonePayment.default;
  }
});
Object.defineProperty(exports, "phoneRotation", {
  enumerable: true,
  get: function () {
    return _phoneRotation.default;
  }
});
Object.defineProperty(exports, "picking", {
  enumerable: true,
  get: function () {
    return _picking.default;
  }
});
Object.defineProperty(exports, "pieChart", {
  enumerable: true,
  get: function () {
    return _pieChart.default;
  }
});
Object.defineProperty(exports, "pin", {
  enumerable: true,
  get: function () {
    return _pin.default;
  }
});
Object.defineProperty(exports, "pinterest", {
  enumerable: true,
  get: function () {
    return _pinterest.default;
  }
});
Object.defineProperty(exports, "pinterestColour", {
  enumerable: true,
  get: function () {
    return _pinterestColour.default;
  }
});
Object.defineProperty(exports, "plasticBag", {
  enumerable: true,
  get: function () {
    return _plasticBag.default;
  }
});
Object.defineProperty(exports, "plasticBottle", {
  enumerable: true,
  get: function () {
    return _plasticBottle.default;
  }
});
Object.defineProperty(exports, "plasticBottleCap", {
  enumerable: true,
  get: function () {
    return _plasticBottleCap.default;
  }
});
Object.defineProperty(exports, "play", {
  enumerable: true,
  get: function () {
    return _play.default;
  }
});
Object.defineProperty(exports, "playArea", {
  enumerable: true,
  get: function () {
    return _playArea.default;
  }
});
Object.defineProperty(exports, "plus", {
  enumerable: true,
  get: function () {
    return _plus.default;
  }
});
Object.defineProperty(exports, "plusCircle", {
  enumerable: true,
  get: function () {
    return _plusCircle.default;
  }
});
Object.defineProperty(exports, "plusSmall", {
  enumerable: true,
  get: function () {
    return _plusSmall.default;
  }
});
Object.defineProperty(exports, "podcast", {
  enumerable: true,
  get: function () {
    return _podcast.default;
  }
});
Object.defineProperty(exports, "pork", {
  enumerable: true,
  get: function () {
    return _pork.default;
  }
});
Object.defineProperty(exports, "power", {
  enumerable: true,
  get: function () {
    return _power.default;
  }
});
Object.defineProperty(exports, "pram", {
  enumerable: true,
  get: function () {
    return _pram.default;
  }
});
Object.defineProperty(exports, "printer", {
  enumerable: true,
  get: function () {
    return _printer.default;
  }
});
Object.defineProperty(exports, "questionMark", {
  enumerable: true,
  get: function () {
    return _questionMark.default;
  }
});
Object.defineProperty(exports, "questionMarkCircle", {
  enumerable: true,
  get: function () {
    return _questionMarkCircle.default;
  }
});
Object.defineProperty(exports, "receipt", {
  enumerable: true,
  get: function () {
    return _receipt.default;
  }
});
Object.defineProperty(exports, "rectangleHorizontal", {
  enumerable: true,
  get: function () {
    return _rectangleHorizontal.default;
  }
});
Object.defineProperty(exports, "rectangleHorizontalDouble", {
  enumerable: true,
  get: function () {
    return _rectangleHorizontalDouble.default;
  }
});
Object.defineProperty(exports, "rectangleHorizontalThin", {
  enumerable: true,
  get: function () {
    return _rectangleHorizontalThin.default;
  }
});
Object.defineProperty(exports, "rectangleHorizontalThinTripple", {
  enumerable: true,
  get: function () {
    return _rectangleHorizontalThinTripple.default;
  }
});
Object.defineProperty(exports, "rectanglePairUneven", {
  enumerable: true,
  get: function () {
    return _rectanglePairUneven.default;
  }
});
Object.defineProperty(exports, "rectangleVertical", {
  enumerable: true,
  get: function () {
    return _rectangleVertical.default;
  }
});
Object.defineProperty(exports, "rectangleVerticalDouble", {
  enumerable: true,
  get: function () {
    return _rectangleVerticalDouble.default;
  }
});
Object.defineProperty(exports, "rectangleVerticalThin", {
  enumerable: true,
  get: function () {
    return _rectangleVerticalThin.default;
  }
});
Object.defineProperty(exports, "recycle", {
  enumerable: true,
  get: function () {
    return _recycle.default;
  }
});
Object.defineProperty(exports, "refilling", {
  enumerable: true,
  get: function () {
    return _refilling.default;
  }
});
Object.defineProperty(exports, "rental", {
  enumerable: true,
  get: function () {
    return _rental.default;
  }
});
Object.defineProperty(exports, "resize", {
  enumerable: true,
  get: function () {
    return _resize.default;
  }
});
Object.defineProperty(exports, "restroom", {
  enumerable: true,
  get: function () {
    return _restroom.default;
  }
});
Object.defineProperty(exports, "restroomBabyCare", {
  enumerable: true,
  get: function () {
    return _restroomBabyCare.default;
  }
});
Object.defineProperty(exports, "restroomMan", {
  enumerable: true,
  get: function () {
    return _restroomMan.default;
  }
});
Object.defineProperty(exports, "restroomManAndChild", {
  enumerable: true,
  get: function () {
    return _restroomManAndChild.default;
  }
});
Object.defineProperty(exports, "restroomWoman", {
  enumerable: true,
  get: function () {
    return _restroomWoman.default;
  }
});
Object.defineProperty(exports, "restroomWomanAndChild", {
  enumerable: true,
  get: function () {
    return _restroomWomanAndChild.default;
  }
});
Object.defineProperty(exports, "returns", {
  enumerable: true,
  get: function () {
    return _returns.default;
  }
});
Object.defineProperty(exports, "reward", {
  enumerable: true,
  get: function () {
    return _reward.default;
  }
});
Object.defineProperty(exports, "rewind", {
  enumerable: true,
  get: function () {
    return _rewind.default;
  }
});
Object.defineProperty(exports, "roomDarkening", {
  enumerable: true,
  get: function () {
    return _roomDarkening.default;
  }
});
Object.defineProperty(exports, "rotate", {
  enumerable: true,
  get: function () {
    return _rotate.default;
  }
});
Object.defineProperty(exports, "ruler", {
  enumerable: true,
  get: function () {
    return _ruler.default;
  }
});
Object.defineProperty(exports, "scanBarcode", {
  enumerable: true,
  get: function () {
    return _scanBarcode.default;
  }
});
Object.defineProperty(exports, "scanQrCode", {
  enumerable: true,
  get: function () {
    return _scanQrCode.default;
  }
});
Object.defineProperty(exports, "scissors", {
  enumerable: true,
  get: function () {
    return _scissors.default;
  }
});
Object.defineProperty(exports, "scooter", {
  enumerable: true,
  get: function () {
    return _scooter.default;
  }
});
Object.defineProperty(exports, "screw", {
  enumerable: true,
  get: function () {
    return _screw.default;
  }
});
Object.defineProperty(exports, "seafood", {
  enumerable: true,
  get: function () {
    return _seafood.default;
  }
});
Object.defineProperty(exports, "securityCamera", {
  enumerable: true,
  get: function () {
    return _securityCamera.default;
  }
});
Object.defineProperty(exports, "selectionAdd", {
  enumerable: true,
  get: function () {
    return _selectionAdd.default;
  }
});
Object.defineProperty(exports, "selectionHidden", {
  enumerable: true,
  get: function () {
    return _selectionHidden.default;
  }
});
Object.defineProperty(exports, "sewingMachine", {
  enumerable: true,
  get: function () {
    return _sewingMachine.default;
  }
});
Object.defineProperty(exports, "shapeCorner", {
  enumerable: true,
  get: function () {
    return _shapeCorner.default;
  }
});
Object.defineProperty(exports, "shapeFree", {
  enumerable: true,
  get: function () {
    return _shapeFree.default;
  }
});
Object.defineProperty(exports, "shapeL", {
  enumerable: true,
  get: function () {
    return _shapeL.default;
  }
});
Object.defineProperty(exports, "shapeOrganic", {
  enumerable: true,
  get: function () {
    return _shapeOrganic.default;
  }
});
Object.defineProperty(exports, "shapeU", {
  enumerable: true,
  get: function () {
    return _shapeU.default;
  }
});
Object.defineProperty(exports, "shareNetwork", {
  enumerable: true,
  get: function () {
    return _shareNetwork.default;
  }
});
Object.defineProperty(exports, "sheerFabric", {
  enumerable: true,
  get: function () {
    return _sheerFabric.default;
  }
});
Object.defineProperty(exports, "shieldCheckmark", {
  enumerable: true,
  get: function () {
    return _shieldCheckmark.default;
  }
});
Object.defineProperty(exports, "shoppingBag", {
  enumerable: true,
  get: function () {
    return _shoppingBag.default;
  }
});
Object.defineProperty(exports, "shoppingBagActive", {
  enumerable: true,
  get: function () {
    return _shoppingBagActive.default;
  }
});
Object.defineProperty(exports, "shoppingBagAdd", {
  enumerable: true,
  get: function () {
    return _shoppingBagAdd.default;
  }
});
Object.defineProperty(exports, "shoppingBagPride", {
  enumerable: true,
  get: function () {
    return _shoppingBagPride.default;
  }
});
Object.defineProperty(exports, "shoppingBagPrideActive", {
  enumerable: true,
  get: function () {
    return _shoppingBagPrideActive.default;
  }
});
Object.defineProperty(exports, "shoppingTrolley", {
  enumerable: true,
  get: function () {
    return _shoppingTrolley.default;
  }
});
Object.defineProperty(exports, "shoppingTrolleyFilled", {
  enumerable: true,
  get: function () {
    return _shoppingTrolleyFilled.default;
  }
});
Object.defineProperty(exports, "shower", {
  enumerable: true,
  get: function () {
    return _shower.default;
  }
});
Object.defineProperty(exports, "shuffle", {
  enumerable: true,
  get: function () {
    return _shuffle.default;
  }
});
Object.defineProperty(exports, "skipNext", {
  enumerable: true,
  get: function () {
    return _skipNext.default;
  }
});
Object.defineProperty(exports, "skipPrevious", {
  enumerable: true,
  get: function () {
    return _skipPrevious.default;
  }
});
Object.defineProperty(exports, "sleepingPositionBack", {
  enumerable: true,
  get: function () {
    return _sleepingPositionBack.default;
  }
});
Object.defineProperty(exports, "sleepingPositionMixed", {
  enumerable: true,
  get: function () {
    return _sleepingPositionMixed.default;
  }
});
Object.defineProperty(exports, "sleepingPositionSide", {
  enumerable: true,
  get: function () {
    return _sleepingPositionSide.default;
  }
});
Object.defineProperty(exports, "sleepingPositionStomach", {
  enumerable: true,
  get: function () {
    return _sleepingPositionStomach.default;
  }
});
Object.defineProperty(exports, "smFacebook", {
  enumerable: true,
  get: function () {
    return _smFacebook.default;
  }
});
Object.defineProperty(exports, "smFacebookFooter", {
  enumerable: true,
  get: function () {
    return _smFacebookFooter.default;
  }
});
Object.defineProperty(exports, "smInstagram", {
  enumerable: true,
  get: function () {
    return _smInstagram.default;
  }
});
Object.defineProperty(exports, "smInstagramFooter", {
  enumerable: true,
  get: function () {
    return _smInstagramFooter.default;
  }
});
Object.defineProperty(exports, "smLine", {
  enumerable: true,
  get: function () {
    return _smLine.default;
  }
});
Object.defineProperty(exports, "smLineFooter", {
  enumerable: true,
  get: function () {
    return _smLineFooter.default;
  }
});
Object.defineProperty(exports, "smLinkedin", {
  enumerable: true,
  get: function () {
    return _smLinkedin.default;
  }
});
Object.defineProperty(exports, "smLinkedinFooter", {
  enumerable: true,
  get: function () {
    return _smLinkedinFooter.default;
  }
});
Object.defineProperty(exports, "smOdnoklassniki", {
  enumerable: true,
  get: function () {
    return _smOdnoklassniki.default;
  }
});
Object.defineProperty(exports, "smOdnoklassnikiFooter", {
  enumerable: true,
  get: function () {
    return _smOdnoklassnikiFooter.default;
  }
});
Object.defineProperty(exports, "smPinterest", {
  enumerable: true,
  get: function () {
    return _smPinterest.default;
  }
});
Object.defineProperty(exports, "smPinterestFooter", {
  enumerable: true,
  get: function () {
    return _smPinterestFooter.default;
  }
});
Object.defineProperty(exports, "smSinaWeibo", {
  enumerable: true,
  get: function () {
    return _smSinaWeibo.default;
  }
});
Object.defineProperty(exports, "smSinaWeiboFooter", {
  enumerable: true,
  get: function () {
    return _smSinaWeiboFooter.default;
  }
});
Object.defineProperty(exports, "smSnapchat", {
  enumerable: true,
  get: function () {
    return _smSnapchat.default;
  }
});
Object.defineProperty(exports, "smSnapchatFooter", {
  enumerable: true,
  get: function () {
    return _smSnapchatFooter.default;
  }
});
Object.defineProperty(exports, "smTwitter", {
  enumerable: true,
  get: function () {
    return _smTwitter.default;
  }
});
Object.defineProperty(exports, "smTwitterFooter", {
  enumerable: true,
  get: function () {
    return _smTwitterFooter.default;
  }
});
Object.defineProperty(exports, "smVkontakte", {
  enumerable: true,
  get: function () {
    return _smVkontakte.default;
  }
});
Object.defineProperty(exports, "smVkontakteFooter", {
  enumerable: true,
  get: function () {
    return _smVkontakteFooter.default;
  }
});
Object.defineProperty(exports, "smWechat", {
  enumerable: true,
  get: function () {
    return _smWechat.default;
  }
});
Object.defineProperty(exports, "smWechatFooter", {
  enumerable: true,
  get: function () {
    return _smWechatFooter.default;
  }
});
Object.defineProperty(exports, "smYouku", {
  enumerable: true,
  get: function () {
    return _smYouku.default;
  }
});
Object.defineProperty(exports, "smYoukuFooter", {
  enumerable: true,
  get: function () {
    return _smYoukuFooter.default;
  }
});
Object.defineProperty(exports, "smYoutube", {
  enumerable: true,
  get: function () {
    return _smYoutube.default;
  }
});
Object.defineProperty(exports, "smYoutubeFooter", {
  enumerable: true,
  get: function () {
    return _smYoutubeFooter.default;
  }
});
Object.defineProperty(exports, "smoking", {
  enumerable: true,
  get: function () {
    return _smoking.default;
  }
});
Object.defineProperty(exports, "smokingStrikethrough", {
  enumerable: true,
  get: function () {
    return _smokingStrikethrough.default;
  }
});
Object.defineProperty(exports, "snapchat", {
  enumerable: true,
  get: function () {
    return _snapchat.default;
  }
});
Object.defineProperty(exports, "snapchatColour", {
  enumerable: true,
  get: function () {
    return _snapchatColour.default;
  }
});
Object.defineProperty(exports, "sofa", {
  enumerable: true,
  get: function () {
    return _sofa.default;
  }
});
Object.defineProperty(exports, "solarEnergy", {
  enumerable: true,
  get: function () {
    return _solarEnergy.default;
  }
});
Object.defineProperty(exports, "solarPanels", {
  enumerable: true,
  get: function () {
    return _solarPanels.default;
  }
});
Object.defineProperty(exports, "solarStorageBattery", {
  enumerable: true,
  get: function () {
    return _solarStorageBattery.default;
  }
});
Object.defineProperty(exports, "sortAscending", {
  enumerable: true,
  get: function () {
    return _sortAscending.default;
  }
});
Object.defineProperty(exports, "sortDescending", {
  enumerable: true,
  get: function () {
    return _sortDescending.default;
  }
});
Object.defineProperty(exports, "speechBubble", {
  enumerable: true,
  get: function () {
    return _speechBubble.default;
  }
});
Object.defineProperty(exports, "speechBubbleActive", {
  enumerable: true,
  get: function () {
    return _speechBubbleActive.default;
  }
});
Object.defineProperty(exports, "spotify", {
  enumerable: true,
  get: function () {
    return _spotify.default;
  }
});
Object.defineProperty(exports, "spotifyColour", {
  enumerable: true,
  get: function () {
    return _spotifyColour.default;
  }
});
Object.defineProperty(exports, "square", {
  enumerable: true,
  get: function () {
    return _square.default;
  }
});
Object.defineProperty(exports, "squareCut", {
  enumerable: true,
  get: function () {
    return _squareCut.default;
  }
});
Object.defineProperty(exports, "squareGrid2x2", {
  enumerable: true,
  get: function () {
    return _squareGrid2x.default;
  }
});
Object.defineProperty(exports, "stack", {
  enumerable: true,
  get: function () {
    return _stack.default;
  }
});
Object.defineProperty(exports, "stackStrikethrough", {
  enumerable: true,
  get: function () {
    return _stackStrikethrough.default;
  }
});
Object.defineProperty(exports, "stairs", {
  enumerable: true,
  get: function () {
    return _stairs.default;
  }
});
Object.defineProperty(exports, "stairsDown", {
  enumerable: true,
  get: function () {
    return _stairsDown.default;
  }
});
Object.defineProperty(exports, "stairsUp", {
  enumerable: true,
  get: function () {
    return _stairsUp.default;
  }
});
Object.defineProperty(exports, "star", {
  enumerable: true,
  get: function () {
    return _star.default;
  }
});
Object.defineProperty(exports, "starFilled", {
  enumerable: true,
  get: function () {
    return _starFilled.default;
  }
});
Object.defineProperty(exports, "starFilledSmall", {
  enumerable: true,
  get: function () {
    return _starFilledSmall.default;
  }
});
Object.defineProperty(exports, "starHalfFilled", {
  enumerable: true,
  get: function () {
    return _starHalfFilled.default;
  }
});
Object.defineProperty(exports, "starHalfFilledSmall", {
  enumerable: true,
  get: function () {
    return _starHalfFilledSmall.default;
  }
});
Object.defineProperty(exports, "starSmall", {
  enumerable: true,
  get: function () {
    return _starSmall.default;
  }
});
Object.defineProperty(exports, "stop", {
  enumerable: true,
  get: function () {
    return _stop.default;
  }
});
Object.defineProperty(exports, "store", {
  enumerable: true,
  get: function () {
    return _store.default;
  }
});
Object.defineProperty(exports, "suitcase", {
  enumerable: true,
  get: function () {
    return _suitcase.default;
  }
});
Object.defineProperty(exports, "sunrise3000", {
  enumerable: true,
  get: function () {
    return _sunrise.default;
  }
});
Object.defineProperty(exports, "surgicalMask", {
  enumerable: true,
  get: function () {
    return _surgicalMask.default;
  }
});
Object.defineProperty(exports, "surgicalMaskOnFace", {
  enumerable: true,
  get: function () {
    return _surgicalMaskOnFace.default;
  }
});
Object.defineProperty(exports, "tShirt", {
  enumerable: true,
  get: function () {
    return _tShirt.default;
  }
});
Object.defineProperty(exports, "tag", {
  enumerable: true,
  get: function () {
    return _tag.default;
  }
});
Object.defineProperty(exports, "tagFilled", {
  enumerable: true,
  get: function () {
    return _tagFilled.default;
  }
});
Object.defineProperty(exports, "takeBack", {
  enumerable: true,
  get: function () {
    return _takeBack.default;
  }
});
Object.defineProperty(exports, "text", {
  enumerable: true,
  get: function () {
    return _text.default;
  }
});
Object.defineProperty(exports, "thermometer", {
  enumerable: true,
  get: function () {
    return _thermometer.default;
  }
});
Object.defineProperty(exports, "thumbsDown", {
  enumerable: true,
  get: function () {
    return _thumbsDown.default;
  }
});
Object.defineProperty(exports, "thumbsDownFilled", {
  enumerable: true,
  get: function () {
    return _thumbsDownFilled.default;
  }
});
Object.defineProperty(exports, "thumbsUp", {
  enumerable: true,
  get: function () {
    return _thumbsUp.default;
  }
});
Object.defineProperty(exports, "thumbsUpFilled", {
  enumerable: true,
  get: function () {
    return _thumbsUpFilled.default;
  }
});
Object.defineProperty(exports, "tiktok", {
  enumerable: true,
  get: function () {
    return _tiktok.default;
  }
});
Object.defineProperty(exports, "tiktokColour", {
  enumerable: true,
  get: function () {
    return _tiktokColour.default;
  }
});
Object.defineProperty(exports, "tinCan", {
  enumerable: true,
  get: function () {
    return _tinCan.default;
  }
});
Object.defineProperty(exports, "tonerCartridge", {
  enumerable: true,
  get: function () {
    return _tonerCartridge.default;
  }
});
Object.defineProperty(exports, "trailer", {
  enumerable: true,
  get: function () {
    return _trailer.default;
  }
});
Object.defineProperty(exports, "transportBus", {
  enumerable: true,
  get: function () {
    return _transportBus.default;
  }
});
Object.defineProperty(exports, "transportTaxi", {
  enumerable: true,
  get: function () {
    return _transportTaxi.default;
  }
});
Object.defineProperty(exports, "transportTrain", {
  enumerable: true,
  get: function () {
    return _transportTrain.default;
  }
});
Object.defineProperty(exports, "transportTram", {
  enumerable: true,
  get: function () {
    return _transportTram.default;
  }
});
Object.defineProperty(exports, "transportTrolleybus", {
  enumerable: true,
  get: function () {
    return _transportTrolleybus.default;
  }
});
Object.defineProperty(exports, "trashCan", {
  enumerable: true,
  get: function () {
    return _trashCan.default;
  }
});
Object.defineProperty(exports, "twitter", {
  enumerable: true,
  get: function () {
    return _twitter.default;
  }
});
Object.defineProperty(exports, "twitterColour", {
  enumerable: true,
  get: function () {
    return _twitterColour.default;
  }
});
Object.defineProperty(exports, "usbPowered", {
  enumerable: true,
  get: function () {
    return _usbPowered.default;
  }
});
Object.defineProperty(exports, "vase", {
  enumerable: true,
  get: function () {
    return _vase.default;
  }
});
Object.defineProperty(exports, "veggie", {
  enumerable: true,
  get: function () {
    return _veggie.default;
  }
});
Object.defineProperty(exports, "visibilityHide", {
  enumerable: true,
  get: function () {
    return _visibilityHide.default;
  }
});
Object.defineProperty(exports, "visibilityShow", {
  enumerable: true,
  get: function () {
    return _visibilityShow.default;
  }
});
Object.defineProperty(exports, "vkontakte", {
  enumerable: true,
  get: function () {
    return _vkontakte.default;
  }
});
Object.defineProperty(exports, "vkontakteColour", {
  enumerable: true,
  get: function () {
    return _vkontakteColour.default;
  }
});
Object.defineProperty(exports, "volumeMute", {
  enumerable: true,
  get: function () {
    return _volumeMute.default;
  }
});
Object.defineProperty(exports, "volumeOff", {
  enumerable: true,
  get: function () {
    return _volumeOff.default;
  }
});
Object.defineProperty(exports, "volumeUp", {
  enumerable: true,
  get: function () {
    return _volumeUp.default;
  }
});
Object.defineProperty(exports, "warmGlow2200", {
  enumerable: true,
  get: function () {
    return _warmGlow.default;
  }
});
Object.defineProperty(exports, "warmWhite2500", {
  enumerable: true,
  get: function () {
    return _warmWhite.default;
  }
});
Object.defineProperty(exports, "warmWhite2700", {
  enumerable: true,
  get: function () {
    return _warmWhite2.default;
  }
});
Object.defineProperty(exports, "warningTriangle", {
  enumerable: true,
  get: function () {
    return _warningTriangle.default;
  }
});
Object.defineProperty(exports, "warningTriangleColour", {
  enumerable: true,
  get: function () {
    return _warningTriangleColour.default;
  }
});
Object.defineProperty(exports, "washableCover", {
  enumerable: true,
  get: function () {
    return _washableCover.default;
  }
});
Object.defineProperty(exports, "waterdrop", {
  enumerable: true,
  get: function () {
    return _waterdrop.default;
  }
});
Object.defineProperty(exports, "waterproof", {
  enumerable: true,
  get: function () {
    return _waterproof.default;
  }
});
Object.defineProperty(exports, "wechat", {
  enumerable: true,
  get: function () {
    return _wechat.default;
  }
});
Object.defineProperty(exports, "wechatColour", {
  enumerable: true,
  get: function () {
    return _wechatColour.default;
  }
});
Object.defineProperty(exports, "weibo", {
  enumerable: true,
  get: function () {
    return _weibo.default;
  }
});
Object.defineProperty(exports, "weiboColour", {
  enumerable: true,
  get: function () {
    return _weiboColour.default;
  }
});
Object.defineProperty(exports, "weight", {
  enumerable: true,
  get: function () {
    return _weight.default;
  }
});
Object.defineProperty(exports, "whatsapp", {
  enumerable: true,
  get: function () {
    return _whatsapp.default;
  }
});
Object.defineProperty(exports, "whatsappColour", {
  enumerable: true,
  get: function () {
    return _whatsappColour.default;
  }
});
Object.defineProperty(exports, "wheat", {
  enumerable: true,
  get: function () {
    return _wheat.default;
  }
});
Object.defineProperty(exports, "wheatStrikethrough", {
  enumerable: true,
  get: function () {
    return _wheatStrikethrough.default;
  }
});
Object.defineProperty(exports, "whiteSpectrum", {
  enumerable: true,
  get: function () {
    return _whiteSpectrum.default;
  }
});
Object.defineProperty(exports, "wifi", {
  enumerable: true,
  get: function () {
    return _wifi.default;
  }
});
Object.defineProperty(exports, "windFarm", {
  enumerable: true,
  get: function () {
    return _windFarm.default;
  }
});
Object.defineProperty(exports, "wineBottle", {
  enumerable: true,
  get: function () {
    return _wineBottle.default;
  }
});
Object.defineProperty(exports, "wineBottleFilled", {
  enumerable: true,
  get: function () {
    return _wineBottleFilled.default;
  }
});
Object.defineProperty(exports, "wineGlass", {
  enumerable: true,
  get: function () {
    return _wineGlass.default;
  }
});
Object.defineProperty(exports, "wirelessCharging", {
  enumerable: true,
  get: function () {
    return _wirelessCharging.default;
  }
});
Object.defineProperty(exports, "wirelessDimming", {
  enumerable: true,
  get: function () {
    return _wirelessDimming.default;
  }
});
Object.defineProperty(exports, "wood", {
  enumerable: true,
  get: function () {
    return _wood.default;
  }
});
Object.defineProperty(exports, "wrench", {
  enumerable: true,
  get: function () {
    return _wrench.default;
  }
});
Object.defineProperty(exports, "youku", {
  enumerable: true,
  get: function () {
    return _youku.default;
  }
});
Object.defineProperty(exports, "youkuColour", {
  enumerable: true,
  get: function () {
    return _youkuColour.default;
  }
});
Object.defineProperty(exports, "youtube", {
  enumerable: true,
  get: function () {
    return _youtube.default;
  }
});
Object.defineProperty(exports, "youtubeColour", {
  enumerable: true,
  get: function () {
    return _youtubeColour.default;
  }
});

var _accessibleDisabled = _interopRequireDefault(require("./paths/accessible-disabled.js"));

var _addOn = _interopRequireDefault(require("./paths/add-on.js"));

var _air = _interopRequireDefault(require("./paths/air.js"));

var _allenKey = _interopRequireDefault(require("./paths/allen-key.js"));

var _aluminiumCan = _interopRequireDefault(require("./paths/aluminium-can.js"));

var _apple = _interopRequireDefault(require("./paths/apple.js"));

var _ar = _interopRequireDefault(require("./paths/ar.js"));

var _archiveBox = _interopRequireDefault(require("./paths/archive-box.js"));

var _arrowClockwise = _interopRequireDefault(require("./paths/arrow-clockwise.js"));

var _arrowCloudIn = _interopRequireDefault(require("./paths/arrow-cloud-in.js"));

var _arrowCloudOut = _interopRequireDefault(require("./paths/arrow-cloud-out.js"));

var _arrowCounterclockwise = _interopRequireDefault(require("./paths/arrow-counterclockwise.js"));

var _arrowDownBackwards = _interopRequireDefault(require("./paths/arrow-down-backwards.js"));

var _arrowDownForwards = _interopRequireDefault(require("./paths/arrow-down-forwards.js"));

var _arrowDownFromBase = _interopRequireDefault(require("./paths/arrow-down-from-base.js"));

var _arrowDownToBase = _interopRequireDefault(require("./paths/arrow-down-to-base.js"));

var _arrowDownToLine = _interopRequireDefault(require("./paths/arrow-down-to-line.js"));

var _arrowDown = _interopRequireDefault(require("./paths/arrow-down.js"));

var _arrowForkRight = _interopRequireDefault(require("./paths/arrow-fork-right.js"));

var _arrowLeftArrowRight = _interopRequireDefault(require("./paths/arrow-left-arrow-right.js"));

var _arrowLeftFromBase = _interopRequireDefault(require("./paths/arrow-left-from-base.js"));

var _arrowLeftRight = _interopRequireDefault(require("./paths/arrow-left-right.js"));

var _arrowLeftToBase = _interopRequireDefault(require("./paths/arrow-left-to-base.js"));

var _arrowLeftToLine = _interopRequireDefault(require("./paths/arrow-left-to-line.js"));

var _arrowLeft = _interopRequireDefault(require("./paths/arrow-left.js"));

var _arrowLevelDown = _interopRequireDefault(require("./paths/arrow-level-down.js"));

var _arrowLevelUp = _interopRequireDefault(require("./paths/arrow-level-up.js"));

var _arrowOnPath = _interopRequireDefault(require("./paths/arrow-on-path.js"));

var _arrowPairSquarepath = _interopRequireDefault(require("./paths/arrow-pair-squarepath.js"));

var _arrowRightFromBase = _interopRequireDefault(require("./paths/arrow-right-from-base.js"));

var _arrowRightToBase = _interopRequireDefault(require("./paths/arrow-right-to-base.js"));

var _arrowRightToLine = _interopRequireDefault(require("./paths/arrow-right-to-line.js"));

var _arrowRight = _interopRequireDefault(require("./paths/arrow-right.js"));

var _arrowUTurnBackwards = _interopRequireDefault(require("./paths/arrow-u-turn-backwards.js"));

var _arrowUTurnForwards = _interopRequireDefault(require("./paths/arrow-u-turn-forwards.js"));

var _arrowUpArrowDown = _interopRequireDefault(require("./paths/arrow-up-arrow-down.js"));

var _arrowUpBackwards = _interopRequireDefault(require("./paths/arrow-up-backwards.js"));

var _arrowUpDown = _interopRequireDefault(require("./paths/arrow-up-down.js"));

var _arrowUpForwards = _interopRequireDefault(require("./paths/arrow-up-forwards.js"));

var _arrowUpFromBase = _interopRequireDefault(require("./paths/arrow-up-from-base.js"));

var _arrowUpToBase = _interopRequireDefault(require("./paths/arrow-up-to-base.js"));

var _arrowUpToLine = _interopRequireDefault(require("./paths/arrow-up-to-line.js"));

var _arrowUp = _interopRequireDefault(require("./paths/arrow-up.js"));

var _arrowsInward = _interopRequireDefault(require("./paths/arrows-inward.js"));

var _atm = _interopRequireDefault(require("./paths/atm.js"));

var _babyBottle = _interopRequireDefault(require("./paths/baby-bottle.js"));

var _babyStroller = _interopRequireDefault(require("./paths/baby-stroller.js"));

var _backwardEnd = _interopRequireDefault(require("./paths/backward-end.js"));

var _bandAid = _interopRequireDefault(require("./paths/band-aid.js"));

var _barChartDowntrend = _interopRequireDefault(require("./paths/bar-chart-downtrend.js"));

var _barChartUptrend = _interopRequireDefault(require("./paths/bar-chart-uptrend.js"));

var _battery = _interopRequireDefault(require("./paths/battery-0.js"));

var _battery2 = _interopRequireDefault(require("./paths/battery-100.js"));

var _battery3 = _interopRequireDefault(require("./paths/battery-25.js"));

var _battery4 = _interopRequireDefault(require("./paths/battery-50.js"));

var _battery5 = _interopRequireDefault(require("./paths/battery-75.js"));

var _batteryCharging = _interopRequireDefault(require("./paths/battery-charging.js"));

var _beamAngle = _interopRequireDefault(require("./paths/beam-angle.js"));

var _beef = _interopRequireDefault(require("./paths/beef.js"));

var _bell = _interopRequireDefault(require("./paths/bell.js"));

var _bike = _interopRequireDefault(require("./paths/bike.js"));

var _blockOut = _interopRequireDefault(require("./paths/block-out.js"));

var _bookmark = _interopRequireDefault(require("./paths/bookmark.js"));

var _boxCancel = _interopRequireDefault(require("./paths/box-cancel.js"));

var _boxExchange = _interopRequireDefault(require("./paths/box-exchange.js"));

var _boxExpress = _interopRequireDefault(require("./paths/box-express.js"));

var _boxRepeat = _interopRequireDefault(require("./paths/box-repeat.js"));

var _boxReturn = _interopRequireDefault(require("./paths/box-return.js"));

var _box = _interopRequireDefault(require("./paths/box.js"));

var _briefcaseCheckmark = _interopRequireDefault(require("./paths/briefcase-checkmark.js"));

var _briefcase = _interopRequireDefault(require("./paths/briefcase.js"));

var _brightnessDown = _interopRequireDefault(require("./paths/brightness-down.js"));

var _brightnessUp = _interopRequireDefault(require("./paths/brightness-up.js"));

var _bucket = _interopRequireDefault(require("./paths/bucket.js"));

var _bulldozer = _interopRequireDefault(require("./paths/bulldozer.js"));

var _bullet = _interopRequireDefault(require("./paths/bullet.js"));

var _calendar = _interopRequireDefault(require("./paths/calendar-90.js"));

var _calendar2 = _interopRequireDefault(require("./paths/calendar.js"));

var _camera = _interopRequireDefault(require("./paths/camera.js"));

var _candleLight = _interopRequireDefault(require("./paths/candle-light-1800.js"));

var _carElectric = _interopRequireDefault(require("./paths/car-electric.js"));

var _carFittingBold = _interopRequireDefault(require("./paths/car-fitting-bold.js"));

var _car = _interopRequireDefault(require("./paths/car.js"));

var _cargoBike = _interopRequireDefault(require("./paths/cargo-bike.js"));

var _carton = _interopRequireDefault(require("./paths/carton.js"));

var _certificate = _interopRequireDefault(require("./paths/certificate.js"));

var _charging = _interopRequireDefault(require("./paths/charging.js"));

var _chat = _interopRequireDefault(require("./paths/chat.js"));

var _checkmarkBox = _interopRequireDefault(require("./paths/checkmark-box.js"));

var _checkmarkCircle = _interopRequireDefault(require("./paths/checkmark-circle.js"));

var _checkmarkSmall = _interopRequireDefault(require("./paths/checkmark-small.js"));

var _checkmark = _interopRequireDefault(require("./paths/checkmark.js"));

var _chevronDoubleDownSmall = _interopRequireDefault(require("./paths/chevron-double-down-small.js"));

var _chevronDoubleDown = _interopRequireDefault(require("./paths/chevron-double-down.js"));

var _chevronDoubleLeftSmall = _interopRequireDefault(require("./paths/chevron-double-left-small.js"));

var _chevronDoubleLeft = _interopRequireDefault(require("./paths/chevron-double-left.js"));

var _chevronDoubleRightSmall = _interopRequireDefault(require("./paths/chevron-double-right-small.js"));

var _chevronDoubleRight = _interopRequireDefault(require("./paths/chevron-double-right.js"));

var _chevronDoubleUpSmall = _interopRequireDefault(require("./paths/chevron-double-up-small.js"));

var _chevronDoubleUp = _interopRequireDefault(require("./paths/chevron-double-up.js"));

var _chevronDownSmall = _interopRequireDefault(require("./paths/chevron-down-small.js"));

var _chevronDown = _interopRequireDefault(require("./paths/chevron-down.js"));

var _chevronLeftSlashChevronRight = _interopRequireDefault(require("./paths/chevron-left-slash-chevron-right.js"));

var _chevronLeftSmall = _interopRequireDefault(require("./paths/chevron-left-small.js"));

var _chevronLeft = _interopRequireDefault(require("./paths/chevron-left.js"));

var _chevronRightSmall = _interopRequireDefault(require("./paths/chevron-right-small.js"));

var _chevronRight = _interopRequireDefault(require("./paths/chevron-right.js"));

var _chevronUpChevronDownSmall = _interopRequireDefault(require("./paths/chevron-up-chevron-down-small.js"));

var _chevronUpChevronDown = _interopRequireDefault(require("./paths/chevron-up-chevron-down.js"));

var _chevronUpSmall = _interopRequireDefault(require("./paths/chevron-up-small.js"));

var _chevronUp = _interopRequireDefault(require("./paths/chevron-up.js"));

var _chicken = _interopRequireDefault(require("./paths/chicken.js"));

var _circleFilled = _interopRequireDefault(require("./paths/circle-filled.js"));

var _circleFourSegmentsFilled = _interopRequireDefault(require("./paths/circle-four-segments-filled.js"));

var _circleFourSegments = _interopRequireDefault(require("./paths/circle-four-segments.js"));

var _circleHalf = _interopRequireDefault(require("./paths/circle-half.js"));

var _circleThreeSegmentsFilled = _interopRequireDefault(require("./paths/circle-three-segments-filled.js"));

var _circleThreeSegments = _interopRequireDefault(require("./paths/circle-three-segments.js"));

var _circle = _interopRequireDefault(require("./paths/circle.js"));

var _circlepathThreeTriangles = _interopRequireDefault(require("./paths/circlepath-three-triangles.js"));

var _circlepathTwoTriangles = _interopRequireDefault(require("./paths/circlepath-two-triangles.js"));

var _cleanSparkles = _interopRequireDefault(require("./paths/clean-sparkles.js"));

var _clickAndCollectStrikethrough = _interopRequireDefault(require("./paths/click-and-collect-strikethrough.js"));

var _clickAndCollect = _interopRequireDefault(require("./paths/click-and-collect.js"));

var _clipboardCheckmark = _interopRequireDefault(require("./paths/clipboard-checkmark.js"));

var _clipboardStrikethrough = _interopRequireDefault(require("./paths/clipboard-strikethrough.js"));

var _clipboard = _interopRequireDefault(require("./paths/clipboard.js"));

var _clock = _interopRequireDefault(require("./paths/clock.js"));

var _coatHanger = _interopRequireDefault(require("./paths/coat-hanger.js"));

var _coffeeWaste = _interopRequireDefault(require("./paths/coffee-waste.js"));

var _coldDrinkContents = _interopRequireDefault(require("./paths/cold-drink-contents.js"));

var _coldDrink = _interopRequireDefault(require("./paths/cold-drink.js"));

var _colourFan = _interopRequireDefault(require("./paths/colour-fan.js"));

var _colourSpectrum = _interopRequireDefault(require("./paths/colour-spectrum.js"));

var _contactlessPayment = _interopRequireDefault(require("./paths/contactless-payment.js"));

var _contract = _interopRequireDefault(require("./paths/contract.js"));

var _coolDaylight = _interopRequireDefault(require("./paths/cool-daylight-5000.js"));

var _coolDaylight2 = _interopRequireDefault(require("./paths/cool-daylight-5200.js"));

var _coolSky = _interopRequireDefault(require("./paths/cool-sky-6000.js"));

var _coolWhite = _interopRequireDefault(require("./paths/cool-white-4000.js"));

var _cooling = _interopRequireDefault(require("./paths/cooling.js"));

var _copy = _interopRequireDefault(require("./paths/copy.js"));

var _coupon = _interopRequireDefault(require("./paths/coupon.js"));

var _createNew = _interopRequireDefault(require("./paths/create-new.js"));

var _creditCard = _interopRequireDefault(require("./paths/credit-card.js"));

var _crossBox = _interopRequireDefault(require("./paths/cross-box.js"));

var _crossCircle = _interopRequireDefault(require("./paths/cross-circle.js"));

var _crossSmall = _interopRequireDefault(require("./paths/cross-small.js"));

var _cross = _interopRequireDefault(require("./paths/cross.js"));

var _crosshair = _interopRequireDefault(require("./paths/crosshair.js"));

var _cube3dFrontFilled = _interopRequireDefault(require("./paths/cube-3d-front-filled.js"));

var _cube3dTopFilled = _interopRequireDefault(require("./paths/cube-3d-top-filled.js"));

var _cube3d = _interopRequireDefault(require("./paths/cube-3d.js"));

var _cupFilled = _interopRequireDefault(require("./paths/cup-filled.js"));

var _cup = _interopRequireDefault(require("./paths/cup.js"));

var _cutlery = _interopRequireDefault(require("./paths/cutlery.js"));

var _dataChart = _interopRequireDefault(require("./paths/data-chart.js"));

var _deliveryTruckStrikethrough = _interopRequireDefault(require("./paths/delivery-truck-strikethrough.js"));

var _deliveryTruck = _interopRequireDefault(require("./paths/delivery-truck.js"));

var _dimmable = _interopRequireDefault(require("./paths/dimmable.js"));

var _dirt = _interopRequireDefault(require("./paths/dirt.js"));

var _discountTag = _interopRequireDefault(require("./paths/discount-tag.js"));

var _display = _interopRequireDefault(require("./paths/display.js"));

var _documentAdd = _interopRequireDefault(require("./paths/document-add.js"));

var _documentAlert = _interopRequireDefault(require("./paths/document-alert.js"));

var _documentCheckmark = _interopRequireDefault(require("./paths/document-checkmark.js"));

var _documentFinancial = _interopRequireDefault(require("./paths/document-financial.js"));

var _documentList = _interopRequireDefault(require("./paths/document-list.js"));

var _documentMagnifyingGlass = _interopRequireDefault(require("./paths/document-magnifying-glass.js"));

var _documentPencil = _interopRequireDefault(require("./paths/document-pencil.js"));

var _documentUpload = _interopRequireDefault(require("./paths/document-upload.js"));

var _document = _interopRequireDefault(require("./paths/document.js"));

var _dog = _interopRequireDefault(require("./paths/dog.js"));

var _drill = _interopRequireDefault(require("./paths/drill.js"));

var _earStrikethrough = _interopRequireDefault(require("./paths/ear-strikethrough.js"));

var _ear = _interopRequireDefault(require("./paths/ear.js"));

var _eggStrikethrough = _interopRequireDefault(require("./paths/egg-strikethrough.js"));

var _egg = _interopRequireDefault(require("./paths/egg.js"));

var _electronicCircle = _interopRequireDefault(require("./paths/electronic-circle.js"));

var _ellipsesHorizontal = _interopRequireDefault(require("./paths/ellipses-horizontal.js"));

var _ellipsesVertical = _interopRequireDefault(require("./paths/ellipses-vertical.js"));

var _ellipsis = _interopRequireDefault(require("./paths/ellipsis.js"));

var _escalatorDown = _interopRequireDefault(require("./paths/escalator-down.js"));

var _escalatorUpDown = _interopRequireDefault(require("./paths/escalator-up-down.js"));

var _escalatorUp = _interopRequireDefault(require("./paths/escalator-up.js"));

var _expand = _interopRequireDefault(require("./paths/expand.js"));

var _fabric = _interopRequireDefault(require("./paths/fabric.js"));

var _factory = _interopRequireDefault(require("./paths/factory.js"));

var _fallingBoxes = _interopRequireDefault(require("./paths/falling-boxes.js"));

var _familyGenderMen = _interopRequireDefault(require("./paths/family-gender-men.js"));

var _familyGenderMixed = _interopRequireDefault(require("./paths/family-gender-mixed.js"));

var _familyGenderWomen = _interopRequireDefault(require("./paths/family-gender-women.js"));

var _fan = _interopRequireDefault(require("./paths/fan.js"));

var _fastForward = _interopRequireDefault(require("./paths/fast-forward.js"));

var _fauxLeather = _interopRequireDefault(require("./paths/faux-leather.js"));

var _feedbackDissatisfied = _interopRequireDefault(require("./paths/feedback-dissatisfied.js"));

var _feedbackHappy = _interopRequireDefault(require("./paths/feedback-happy.js"));

var _feedbackNeutral = _interopRequireDefault(require("./paths/feedback-neutral.js"));

var _feedbackSad = _interopRequireDefault(require("./paths/feedback-sad.js"));

var _feedbackSatisfied = _interopRequireDefault(require("./paths/feedback-satisfied.js"));

var _filters = _interopRequireDefault(require("./paths/filters.js"));

var _financing = _interopRequireDefault(require("./paths/financing.js"));

var _firstAidRoomCrescent = _interopRequireDefault(require("./paths/first-aid-room-crescent.js"));

var _firstAidRoomCross = _interopRequireDefault(require("./paths/first-aid-room-cross.js"));

var _fish = _interopRequireDefault(require("./paths/fish.js"));

var _flag = _interopRequireDefault(require("./paths/flag.js"));

var _flame = _interopRequireDefault(require("./paths/flame.js"));

var _fluorescentLamp = _interopRequireDefault(require("./paths/fluorescent-lamp.js"));

var _folder = _interopRequireDefault(require("./paths/folder.js"));

var _footprint = _interopRequireDefault(require("./paths/footprint.js"));

var _forwardEnd = _interopRequireDefault(require("./paths/forward-end.js"));

var _fullScreen = _interopRequireDefault(require("./paths/full-screen.js"));

var _fullscreen = _interopRequireDefault(require("./paths/fullscreen.js"));

var _furnitureTrolleyLoaded = _interopRequireDefault(require("./paths/furniture-trolley-loaded.js"));

var _furnitureTrolley = _interopRequireDefault(require("./paths/furniture-trolley.js"));

var _garbageTruck = _interopRequireDefault(require("./paths/garbage-truck.js"));

var _gear = _interopRequireDefault(require("./paths/gear.js"));

var _giftBagActive = _interopRequireDefault(require("./paths/gift-bag-active.js"));

var _giftBagAdd = _interopRequireDefault(require("./paths/gift-bag-add.js"));

var _giftBag = _interopRequireDefault(require("./paths/gift-bag.js"));

var _giftBoxActive = _interopRequireDefault(require("./paths/gift-box-active.js"));

var _giftBoxFilled = _interopRequireDefault(require("./paths/gift-box-filled.js"));

var _giftBox = _interopRequireDefault(require("./paths/gift-box.js"));

var _giftCard = _interopRequireDefault(require("./paths/gift-card.js"));

var _globe = _interopRequireDefault(require("./paths/globe.js"));

var _guarantee = _interopRequireDefault(require("./paths/guarantee-10.js"));

var _guarantee2 = _interopRequireDefault(require("./paths/guarantee-15.js"));

var _guarantee3 = _interopRequireDefault(require("./paths/guarantee-2.js"));

var _guarantee4 = _interopRequireDefault(require("./paths/guarantee-25.js"));

var _guarantee5 = _interopRequireDefault(require("./paths/guarantee-3.js"));

var _guarantee6 = _interopRequireDefault(require("./paths/guarantee-5.js"));

var _handGestures = _interopRequireDefault(require("./paths/hand-gestures.js"));

var _handMove = _interopRequireDefault(require("./paths/hand-move.js"));

var _handPoint = _interopRequireDefault(require("./paths/hand-point.js"));

var _handStrikethrough = _interopRequireDefault(require("./paths/hand-strikethrough.js"));

var _handTouch = _interopRequireDefault(require("./paths/hand-touch.js"));

var _handWithBag = _interopRequireDefault(require("./paths/hand-with-bag.js"));

var _handWithBox = _interopRequireDefault(require("./paths/hand-with-box.js"));

var _handWithDiscount = _interopRequireDefault(require("./paths/hand-with-discount.js"));

var _handWithDrop = _interopRequireDefault(require("./paths/hand-with-drop.js"));

var _handWithDrops = _interopRequireDefault(require("./paths/hand-with-drops.js"));

var _handWithHeart = _interopRequireDefault(require("./paths/hand-with-heart.js"));

var _handWithKey = _interopRequireDefault(require("./paths/hand-with-key.js"));

var _handWithPlate = _interopRequireDefault(require("./paths/hand-with-plate.js"));

var _handWithSparkles = _interopRequireDefault(require("./paths/hand-with-sparkles.js"));

var _hand = _interopRequireDefault(require("./paths/hand.js"));

var _handle = _interopRequireDefault(require("./paths/handle.js"));

var _heartFilled = _interopRequireDefault(require("./paths/heart-filled.js"));

var _heart = _interopRequireDefault(require("./paths/heart.js"));

var _heatPump = _interopRequireDefault(require("./paths/heat-pump.js"));

var _history = _interopRequireDefault(require("./paths/history.js"));

var _home = _interopRequireDefault(require("./paths/home.js"));

var _hotDog = _interopRequireDefault(require("./paths/hot-dog.js"));

var _hotDrink = _interopRequireDefault(require("./paths/hot-drink.js"));

var _iceCream = _interopRequireDefault(require("./paths/ice-cream.js"));

var _id = _interopRequireDefault(require("./paths/id.js"));

var _imageStack = _interopRequireDefault(require("./paths/image-stack.js"));

var _imageStrikethrough = _interopRequireDefault(require("./paths/image-strikethrough.js"));

var _image = _interopRequireDefault(require("./paths/image.js"));

var _incorrect = _interopRequireDefault(require("./paths/incorrect.js"));

var _informationCircle = _interopRequireDefault(require("./paths/information-circle.js"));

var _information = _interopRequireDefault(require("./paths/information.js"));

var _institution = _interopRequireDefault(require("./paths/institution.js"));

var _inverter = _interopRequireDefault(require("./paths/inverter.js"));

var _kickScooter = _interopRequireDefault(require("./paths/kick-scooter.js"));

var _lamb = _interopRequireDefault(require("./paths/lamb.js"));

var _laptopCheckmark = _interopRequireDefault(require("./paths/laptop-checkmark.js"));

var _laptopMagnifyingGlass = _interopRequireDefault(require("./paths/laptop-magnifying-glass.js"));

var _laptopPencil = _interopRequireDefault(require("./paths/laptop-pencil.js"));

var _laptop = _interopRequireDefault(require("./paths/laptop.js"));

var _layoutAlternative = _interopRequireDefault(require("./paths/layout-alternative.js"));

var _layout = _interopRequireDefault(require("./paths/layout.js"));

var _leaf = _interopRequireDefault(require("./paths/leaf.js"));

var _leatherAndFauxLeather = _interopRequireDefault(require("./paths/leather-and-faux-leather.js"));

var _leather = _interopRequireDefault(require("./paths/leather.js"));

var _liftDown = _interopRequireDefault(require("./paths/lift-down.js"));

var _liftFurnitureTrolley = _interopRequireDefault(require("./paths/lift-furniture-trolley.js"));

var _liftShoppingTrolley = _interopRequireDefault(require("./paths/lift-shopping-trolley.js"));

var _liftUpDown = _interopRequireDefault(require("./paths/lift-up-down.js"));

var _liftUp = _interopRequireDefault(require("./paths/lift-up.js"));

var _lightFiltering = _interopRequireDefault(require("./paths/light-filtering.js"));

var _lightbulbIncandescent = _interopRequireDefault(require("./paths/lightbulb-incandescent.js"));

var _lightbulbLedAlternative = _interopRequireDefault(require("./paths/lightbulb-led-alternative.js"));

var _lightbulbLed = _interopRequireDefault(require("./paths/lightbulb-led.js"));

var _lightbulbWithRays = _interopRequireDefault(require("./paths/lightbulb-with-rays.js"));

var _linkOut = _interopRequireDefault(require("./paths/link-out.js"));

var _link = _interopRequireDefault(require("./paths/link.js"));

var _list = _interopRequireDefault(require("./paths/list.js"));

var _liveVideo = _interopRequireDefault(require("./paths/live-video.js"));

var _locationPinFilled = _interopRequireDefault(require("./paths/location-pin-filled.js"));

var _locationPinSmallFilled = _interopRequireDefault(require("./paths/location-pin-small-filled.js"));

var _locationPinSmall = _interopRequireDefault(require("./paths/location-pin-small.js"));

var _locationPin = _interopRequireDefault(require("./paths/location-pin.js"));

var _locationPointer = _interopRequireDefault(require("./paths/location-pointer.js"));

var _lockOpen = _interopRequireDefault(require("./paths/lock-open.js"));

var _lock = _interopRequireDefault(require("./paths/lock.js"));

var _lockers = _interopRequireDefault(require("./paths/lockers.js"));

var _magnifyingGlassList = _interopRequireDefault(require("./paths/magnifying-glass-list.js"));

var _magnifyingGlass = _interopRequireDefault(require("./paths/magnifying-glass.js"));

var _mail = _interopRequireDefault(require("./paths/mail.js"));

var _map = _interopRequireDefault(require("./paths/map.js"));

var _mattressComfortZones = _interopRequireDefault(require("./paths/mattress-comfort-zones.js"));

var _mattressExtraFirm = _interopRequireDefault(require("./paths/mattress-extra-firm.js"));

var _mattressFirm = _interopRequireDefault(require("./paths/mattress-firm.js"));

var _mattressFoam = _interopRequireDefault(require("./paths/mattress-foam.js"));

var _mattressHybrid = _interopRequireDefault(require("./paths/mattress-hybrid.js"));

var _mattressLatex = _interopRequireDefault(require("./paths/mattress-latex.js"));

var _mattressMaterialNatural = _interopRequireDefault(require("./paths/mattress-material-natural.js"));

var _mattressMaterialVegan = _interopRequireDefault(require("./paths/mattress-material-vegan.js"));

var _mattressMediumFirm = _interopRequireDefault(require("./paths/mattress-medium-firm.js"));

var _mattressMemoryFoam = _interopRequireDefault(require("./paths/mattress-memory-foam.js"));

var _mattressPlush = _interopRequireDefault(require("./paths/mattress-plush.js"));

var _mattressRollPacked = _interopRequireDefault(require("./paths/mattress-roll-packed.js"));

var _mattressSpringsBonnell = _interopRequireDefault(require("./paths/mattress-springs-bonnell.js"));

var _mattressSpringsMini = _interopRequireDefault(require("./paths/mattress-springs-mini.js"));

var _mattressSpringsPocket = _interopRequireDefault(require("./paths/mattress-springs-pocket.js"));

var _mattressTopper = _interopRequireDefault(require("./paths/mattress-topper.js"));

var _medicCrescent = _interopRequireDefault(require("./paths/medic-crescent.js"));

var _medic = _interopRequireDefault(require("./paths/medic.js"));

var _membershipCard = _interopRequireDefault(require("./paths/membership-card.js"));

var _membershipDigitalCard = _interopRequireDefault(require("./paths/membership-digital-card.js"));

var _menu = _interopRequireDefault(require("./paths/menu.js"));

var _microphone = _interopRequireDefault(require("./paths/microphone.js"));

var _milkBottleStrikethrough = _interopRequireDefault(require("./paths/milk-bottle-strikethrough.js"));

var _milkBottle = _interopRequireDefault(require("./paths/milk-bottle.js"));

var _minusSmall = _interopRequireDefault(require("./paths/minus-small.js"));

var _minus = _interopRequireDefault(require("./paths/minus.js"));

var _missing = _interopRequireDefault(require("./paths/missing.js"));

var _mobileHandover = _interopRequireDefault(require("./paths/mobile-handover.js"));

var _mobile = _interopRequireDefault(require("./paths/mobile.js"));

var _moneyBills = _interopRequireDefault(require("./paths/money-bills.js"));

var _moneyCash = _interopRequireDefault(require("./paths/money-cash.js"));

var _moneyCoins = _interopRequireDefault(require("./paths/money-coins.js"));

var _motionSensor = _interopRequireDefault(require("./paths/motion-sensor.js"));

var _motorBike = _interopRequireDefault(require("./paths/motor-bike.js"));

var _network = _interopRequireDefault(require("./paths/network.js"));

var _note = _interopRequireDefault(require("./paths/note.js"));

var _noticeCircle = _interopRequireDefault(require("./paths/notice-circle.js"));

var _noticeSmall = _interopRequireDefault(require("./paths/notice-small.js"));

var _notice = _interopRequireDefault(require("./paths/notice.js"));

var _oilContainer = _interopRequireDefault(require("./paths/oil-container.js"));

var _oval = _interopRequireDefault(require("./paths/oval.js"));

var _paintbrush = _interopRequireDefault(require("./paths/paintbrush.js"));

var _pairing = _interopRequireDefault(require("./paths/pairing.js"));

var _paperTowels = _interopRequireDefault(require("./paths/paper-towels.js"));

var _paperclip = _interopRequireDefault(require("./paths/paperclip.js"));

var _parkingGarage = _interopRequireDefault(require("./paths/parking-garage.js"));

var _parking = _interopRequireDefault(require("./paths/parking.js"));

var _pass = _interopRequireDefault(require("./paths/pass.js"));

var _pause = _interopRequireDefault(require("./paths/pause.js"));

var _pedestrianWithWalkingStick = _interopRequireDefault(require("./paths/pedestrian-with-walking-stick.js"));

var _pedestrian = _interopRequireDefault(require("./paths/pedestrian.js"));

var _pencil = _interopRequireDefault(require("./paths/pencil.js"));

var _people = _interopRequireDefault(require("./paths/people.js"));

var _personActive = _interopRequireDefault(require("./paths/person-active.js"));

var _person = _interopRequireDefault(require("./paths/person.js"));

var _phonePayment = _interopRequireDefault(require("./paths/phone-payment.js"));

var _phoneRotation = _interopRequireDefault(require("./paths/phone-rotation.js"));

var _phone = _interopRequireDefault(require("./paths/phone.js"));

var _picking = _interopRequireDefault(require("./paths/picking.js"));

var _pieChart = _interopRequireDefault(require("./paths/pie-chart.js"));

var _pin = _interopRequireDefault(require("./paths/pin.js"));

var _plasticBag = _interopRequireDefault(require("./paths/plastic-bag.js"));

var _plasticBottleCap = _interopRequireDefault(require("./paths/plastic-bottle-cap.js"));

var _plasticBottle = _interopRequireDefault(require("./paths/plastic-bottle.js"));

var _playArea = _interopRequireDefault(require("./paths/play-area.js"));

var _play = _interopRequireDefault(require("./paths/play.js"));

var _plusCircle = _interopRequireDefault(require("./paths/plus-circle.js"));

var _plusSmall = _interopRequireDefault(require("./paths/plus-small.js"));

var _plus = _interopRequireDefault(require("./paths/plus.js"));

var _podcast = _interopRequireDefault(require("./paths/podcast.js"));

var _pork = _interopRequireDefault(require("./paths/pork.js"));

var _power = _interopRequireDefault(require("./paths/power.js"));

var _pram = _interopRequireDefault(require("./paths/pram.js"));

var _printer = _interopRequireDefault(require("./paths/printer.js"));

var _questionMarkCircle = _interopRequireDefault(require("./paths/question-mark-circle.js"));

var _questionMark = _interopRequireDefault(require("./paths/question-mark.js"));

var _receipt = _interopRequireDefault(require("./paths/receipt.js"));

var _rectangleHorizontalDouble = _interopRequireDefault(require("./paths/rectangle-horizontal-double.js"));

var _rectangleHorizontalThinTripple = _interopRequireDefault(require("./paths/rectangle-horizontal-thin-tripple.js"));

var _rectangleHorizontalThin = _interopRequireDefault(require("./paths/rectangle-horizontal-thin.js"));

var _rectangleHorizontal = _interopRequireDefault(require("./paths/rectangle-horizontal.js"));

var _rectanglePairUneven = _interopRequireDefault(require("./paths/rectangle-pair-uneven.js"));

var _rectangleVerticalDouble = _interopRequireDefault(require("./paths/rectangle-vertical-double.js"));

var _rectangleVerticalThin = _interopRequireDefault(require("./paths/rectangle-vertical-thin.js"));

var _rectangleVertical = _interopRequireDefault(require("./paths/rectangle-vertical.js"));

var _recycle = _interopRequireDefault(require("./paths/recycle.js"));

var _refilling = _interopRequireDefault(require("./paths/refilling.js"));

var _rental = _interopRequireDefault(require("./paths/rental.js"));

var _resize = _interopRequireDefault(require("./paths/resize.js"));

var _restroomBabyCare = _interopRequireDefault(require("./paths/restroom-baby-care.js"));

var _restroomManAndChild = _interopRequireDefault(require("./paths/restroom-man-and-child.js"));

var _restroomMan = _interopRequireDefault(require("./paths/restroom-man.js"));

var _restroomWomanAndChild = _interopRequireDefault(require("./paths/restroom-woman-and-child.js"));

var _restroomWoman = _interopRequireDefault(require("./paths/restroom-woman.js"));

var _restroom = _interopRequireDefault(require("./paths/restroom.js"));

var _returns = _interopRequireDefault(require("./paths/returns.js"));

var _reward = _interopRequireDefault(require("./paths/reward.js"));

var _rewind = _interopRequireDefault(require("./paths/rewind.js"));

var _roomDarkening = _interopRequireDefault(require("./paths/room-darkening.js"));

var _rotate = _interopRequireDefault(require("./paths/rotate.js"));

var _ruler = _interopRequireDefault(require("./paths/ruler.js"));

var _scanBarcode = _interopRequireDefault(require("./paths/scan-barcode.js"));

var _scanQrCode = _interopRequireDefault(require("./paths/scan-qr-code.js"));

var _scissors = _interopRequireDefault(require("./paths/scissors.js"));

var _scooter = _interopRequireDefault(require("./paths/scooter.js"));

var _screw = _interopRequireDefault(require("./paths/screw.js"));

var _seafood = _interopRequireDefault(require("./paths/seafood.js"));

var _securityCamera = _interopRequireDefault(require("./paths/security-camera.js"));

var _selectionAdd = _interopRequireDefault(require("./paths/selection-add.js"));

var _selectionHidden = _interopRequireDefault(require("./paths/selection-hidden.js"));

var _sewingMachine = _interopRequireDefault(require("./paths/sewing-machine.js"));

var _shapeCorner = _interopRequireDefault(require("./paths/shape-corner.js"));

var _shapeFree = _interopRequireDefault(require("./paths/shape-free.js"));

var _shapeL = _interopRequireDefault(require("./paths/shape-l.js"));

var _shapeOrganic = _interopRequireDefault(require("./paths/shape-organic.js"));

var _shapeU = _interopRequireDefault(require("./paths/shape-u.js"));

var _shareNetwork = _interopRequireDefault(require("./paths/share-network.js"));

var _sheerFabric = _interopRequireDefault(require("./paths/sheer-fabric.js"));

var _shieldCheckmark = _interopRequireDefault(require("./paths/shield-checkmark.js"));

var _shoppingBagActive = _interopRequireDefault(require("./paths/shopping-bag-active.js"));

var _shoppingBagAdd = _interopRequireDefault(require("./paths/shopping-bag-add.js"));

var _shoppingBagPrideActive = _interopRequireDefault(require("./paths/shopping-bag-pride-active.js"));

var _shoppingBagPride = _interopRequireDefault(require("./paths/shopping-bag-pride.js"));

var _shoppingBag = _interopRequireDefault(require("./paths/shopping-bag.js"));

var _shoppingTrolleyFilled = _interopRequireDefault(require("./paths/shopping-trolley-filled.js"));

var _shoppingTrolley = _interopRequireDefault(require("./paths/shopping-trolley.js"));

var _shower = _interopRequireDefault(require("./paths/shower.js"));

var _shuffle = _interopRequireDefault(require("./paths/shuffle.js"));

var _skipNext = _interopRequireDefault(require("./paths/skip-next.js"));

var _skipPrevious = _interopRequireDefault(require("./paths/skip-previous.js"));

var _sleepingPositionBack = _interopRequireDefault(require("./paths/sleeping-position-back.js"));

var _sleepingPositionMixed = _interopRequireDefault(require("./paths/sleeping-position-mixed.js"));

var _sleepingPositionSide = _interopRequireDefault(require("./paths/sleeping-position-side.js"));

var _sleepingPositionStomach = _interopRequireDefault(require("./paths/sleeping-position-stomach.js"));

var _smokingStrikethrough = _interopRequireDefault(require("./paths/smoking-strikethrough.js"));

var _smoking = _interopRequireDefault(require("./paths/smoking.js"));

var _sofa = _interopRequireDefault(require("./paths/sofa.js"));

var _solarEnergy = _interopRequireDefault(require("./paths/solar-energy.js"));

var _solarPanels = _interopRequireDefault(require("./paths/solar-panels.js"));

var _solarStorageBattery = _interopRequireDefault(require("./paths/solar-storage-battery.js"));

var _sortAscending = _interopRequireDefault(require("./paths/sort-ascending.js"));

var _sortDescending = _interopRequireDefault(require("./paths/sort-descending.js"));

var _speechBubbleActive = _interopRequireDefault(require("./paths/speech-bubble-active.js"));

var _speechBubble = _interopRequireDefault(require("./paths/speech-bubble.js"));

var _squareCut = _interopRequireDefault(require("./paths/square-cut.js"));

var _squareGrid2x = _interopRequireDefault(require("./paths/square-grid-2x2.js"));

var _square = _interopRequireDefault(require("./paths/square.js"));

var _stackStrikethrough = _interopRequireDefault(require("./paths/stack-strikethrough.js"));

var _stack = _interopRequireDefault(require("./paths/stack.js"));

var _stairsDown = _interopRequireDefault(require("./paths/stairs-down.js"));

var _stairsUp = _interopRequireDefault(require("./paths/stairs-up.js"));

var _stairs = _interopRequireDefault(require("./paths/stairs.js"));

var _starFilledSmall = _interopRequireDefault(require("./paths/star-filled-small.js"));

var _starFilled = _interopRequireDefault(require("./paths/star-filled.js"));

var _starHalfFilledSmall = _interopRequireDefault(require("./paths/star-half-filled-small.js"));

var _starHalfFilled = _interopRequireDefault(require("./paths/star-half-filled.js"));

var _starSmall = _interopRequireDefault(require("./paths/star-small.js"));

var _star = _interopRequireDefault(require("./paths/star.js"));

var _stop = _interopRequireDefault(require("./paths/stop.js"));

var _store = _interopRequireDefault(require("./paths/store.js"));

var _suitcase = _interopRequireDefault(require("./paths/suitcase.js"));

var _sunrise = _interopRequireDefault(require("./paths/sunrise-3000.js"));

var _surgicalMaskOnFace = _interopRequireDefault(require("./paths/surgical-mask-on-face.js"));

var _surgicalMask = _interopRequireDefault(require("./paths/surgical-mask.js"));

var _tShirt = _interopRequireDefault(require("./paths/t-shirt.js"));

var _tagFilled = _interopRequireDefault(require("./paths/tag-filled.js"));

var _tag = _interopRequireDefault(require("./paths/tag.js"));

var _takeBack = _interopRequireDefault(require("./paths/take-back.js"));

var _text = _interopRequireDefault(require("./paths/text.js"));

var _thermometer = _interopRequireDefault(require("./paths/thermometer.js"));

var _thumbsDownFilled = _interopRequireDefault(require("./paths/thumbs-down-filled.js"));

var _thumbsDown = _interopRequireDefault(require("./paths/thumbs-down.js"));

var _thumbsUpFilled = _interopRequireDefault(require("./paths/thumbs-up-filled.js"));

var _thumbsUp = _interopRequireDefault(require("./paths/thumbs-up.js"));

var _tinCan = _interopRequireDefault(require("./paths/tin-can.js"));

var _tonerCartridge = _interopRequireDefault(require("./paths/toner-cartridge.js"));

var _trailer = _interopRequireDefault(require("./paths/trailer.js"));

var _transportBus = _interopRequireDefault(require("./paths/transport-bus.js"));

var _transportTaxi = _interopRequireDefault(require("./paths/transport-taxi.js"));

var _transportTrain = _interopRequireDefault(require("./paths/transport-train.js"));

var _transportTram = _interopRequireDefault(require("./paths/transport-tram.js"));

var _transportTrolleybus = _interopRequireDefault(require("./paths/transport-trolleybus.js"));

var _trashCan = _interopRequireDefault(require("./paths/trash-can.js"));

var _usbPowered = _interopRequireDefault(require("./paths/usb-powered.js"));

var _vase = _interopRequireDefault(require("./paths/vase.js"));

var _veggie = _interopRequireDefault(require("./paths/veggie.js"));

var _visibilityHide = _interopRequireDefault(require("./paths/visibility-hide.js"));

var _visibilityShow = _interopRequireDefault(require("./paths/visibility-show.js"));

var _volumeMute = _interopRequireDefault(require("./paths/volume-mute.js"));

var _volumeOff = _interopRequireDefault(require("./paths/volume-off.js"));

var _volumeUp = _interopRequireDefault(require("./paths/volume-up.js"));

var _warmGlow = _interopRequireDefault(require("./paths/warm-glow-2200.js"));

var _warmWhite = _interopRequireDefault(require("./paths/warm-white-2500.js"));

var _warmWhite2 = _interopRequireDefault(require("./paths/warm-white-2700.js"));

var _warningTriangleColour = _interopRequireDefault(require("./paths/warning-triangle-colour.js"));

var _warningTriangle = _interopRequireDefault(require("./paths/warning-triangle.js"));

var _washableCover = _interopRequireDefault(require("./paths/washable-cover.js"));

var _waterdrop = _interopRequireDefault(require("./paths/waterdrop.js"));

var _waterproof = _interopRequireDefault(require("./paths/waterproof.js"));

var _weight = _interopRequireDefault(require("./paths/weight.js"));

var _wheatStrikethrough = _interopRequireDefault(require("./paths/wheat-strikethrough.js"));

var _wheat = _interopRequireDefault(require("./paths/wheat.js"));

var _whiteSpectrum = _interopRequireDefault(require("./paths/white-spectrum.js"));

var _wifi = _interopRequireDefault(require("./paths/wifi.js"));

var _windFarm = _interopRequireDefault(require("./paths/wind-farm.js"));

var _wineBottleFilled = _interopRequireDefault(require("./paths/wine-bottle-filled.js"));

var _wineBottle = _interopRequireDefault(require("./paths/wine-bottle.js"));

var _wineGlass = _interopRequireDefault(require("./paths/wine-glass.js"));

var _wirelessCharging = _interopRequireDefault(require("./paths/wireless-charging.js"));

var _wirelessDimming = _interopRequireDefault(require("./paths/wireless-dimming.js"));

var _wood = _interopRequireDefault(require("./paths/wood.js"));

var _wrench = _interopRequireDefault(require("./paths/wrench.js"));

var _applePay = _interopRequireDefault(require("./paths/apple-pay.js"));

var _community = _interopRequireDefault(require("./paths/community.js"));

var _customerService = _interopRequireDefault(require("./paths/customer-service.js"));

var _smFacebookFooter = _interopRequireDefault(require("./paths/sm-facebook-footer.js"));

var _smFacebook = _interopRequireDefault(require("./paths/sm-facebook.js"));

var _smInstagramFooter = _interopRequireDefault(require("./paths/sm-instagram-footer.js"));

var _smInstagram = _interopRequireDefault(require("./paths/sm-instagram.js"));

var _smLineFooter = _interopRequireDefault(require("./paths/sm-line-footer.js"));

var _smLine = _interopRequireDefault(require("./paths/sm-line.js"));

var _smLinkedinFooter = _interopRequireDefault(require("./paths/sm-linkedin-footer.js"));

var _smLinkedin = _interopRequireDefault(require("./paths/sm-linkedin.js"));

var _smOdnoklassnikiFooter = _interopRequireDefault(require("./paths/sm-odnoklassniki-footer.js"));

var _smOdnoklassniki = _interopRequireDefault(require("./paths/sm-odnoklassniki.js"));

var _smPinterestFooter = _interopRequireDefault(require("./paths/sm-pinterest-footer.js"));

var _smPinterest = _interopRequireDefault(require("./paths/sm-pinterest.js"));

var _smSinaWeiboFooter = _interopRequireDefault(require("./paths/sm-sina-weibo-footer.js"));

var _smSinaWeibo = _interopRequireDefault(require("./paths/sm-sina-weibo.js"));

var _smSnapchatFooter = _interopRequireDefault(require("./paths/sm-snapchat-footer.js"));

var _smSnapchat = _interopRequireDefault(require("./paths/sm-snapchat.js"));

var _smTwitterFooter = _interopRequireDefault(require("./paths/sm-twitter-footer.js"));

var _smTwitter = _interopRequireDefault(require("./paths/sm-twitter.js"));

var _smVkontakteFooter = _interopRequireDefault(require("./paths/sm-vkontakte-footer.js"));

var _smVkontakte = _interopRequireDefault(require("./paths/sm-vkontakte.js"));

var _smWechatFooter = _interopRequireDefault(require("./paths/sm-wechat-footer.js"));

var _smWechat = _interopRequireDefault(require("./paths/sm-wechat.js"));

var _smYoukuFooter = _interopRequireDefault(require("./paths/sm-youku-footer.js"));

var _smYouku = _interopRequireDefault(require("./paths/sm-youku.js"));

var _smYoutubeFooter = _interopRequireDefault(require("./paths/sm-youtube-footer.js"));

var _smYoutube = _interopRequireDefault(require("./paths/sm-youtube.js"));

var _facebookColour = _interopRequireDefault(require("./paths/facebook-colour.js"));

var _instagramColour = _interopRequireDefault(require("./paths/instagram-colour.js"));

var _kakaoTalkColour = _interopRequireDefault(require("./paths/kakao-talk-colour.js"));

var _lineColour = _interopRequireDefault(require("./paths/line-colour.js"));

var _linkedinColour = _interopRequireDefault(require("./paths/linkedin-colour.js"));

var _odnoklassnikiColour = _interopRequireDefault(require("./paths/odnoklassniki-colour.js"));

var _pinterestColour = _interopRequireDefault(require("./paths/pinterest-colour.js"));

var _snapchatColour = _interopRequireDefault(require("./paths/snapchat-colour.js"));

var _spotifyColour = _interopRequireDefault(require("./paths/spotify-colour.js"));

var _tiktokColour = _interopRequireDefault(require("./paths/tiktok-colour.js"));

var _twitterColour = _interopRequireDefault(require("./paths/twitter-colour.js"));

var _vkontakteColour = _interopRequireDefault(require("./paths/vkontakte-colour.js"));

var _wechatColour = _interopRequireDefault(require("./paths/wechat-colour.js"));

var _weiboColour = _interopRequireDefault(require("./paths/weibo-colour.js"));

var _whatsappColour = _interopRequireDefault(require("./paths/whatsapp-colour.js"));

var _youkuColour = _interopRequireDefault(require("./paths/youku-colour.js"));

var _youtubeColour = _interopRequireDefault(require("./paths/youtube-colour.js"));

var _facebook = _interopRequireDefault(require("./paths/facebook.js"));

var _instagram = _interopRequireDefault(require("./paths/instagram.js"));

var _kakaoTalk = _interopRequireDefault(require("./paths/kakao-talk.js"));

var _line = _interopRequireDefault(require("./paths/line.js"));

var _linkedin = _interopRequireDefault(require("./paths/linkedin.js"));

var _odnoklassniki = _interopRequireDefault(require("./paths/odnoklassniki.js"));

var _pinterest = _interopRequireDefault(require("./paths/pinterest.js"));

var _snapchat = _interopRequireDefault(require("./paths/snapchat.js"));

var _spotify = _interopRequireDefault(require("./paths/spotify.js"));

var _tiktok = _interopRequireDefault(require("./paths/tiktok.js"));

var _twitter = _interopRequireDefault(require("./paths/twitter.js"));

var _vkontakte = _interopRequireDefault(require("./paths/vkontakte.js"));

var _wechat = _interopRequireDefault(require("./paths/wechat.js"));

var _weibo = _interopRequireDefault(require("./paths/weibo.js"));

var _whatsapp = _interopRequireDefault(require("./paths/whatsapp.js"));

var _youku = _interopRequireDefault(require("./paths/youku.js"));

var _youtube = _interopRequireDefault(require("./paths/youtube.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }